!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).EmblaCarousel=t()}(this,(function(){"use strict";function n(n){return"number"==typeof n}function t(n){return"string"==typeof n}function e(n){return"boolean"==typeof n}function r(n){return"[object Object]"===Object.prototype.toString.call(n)}function o(n){return Math.abs(n)}function i(n){return Math.sign(n)}function c(n,t){return o(n-t)}function u(n){return f(n).map(Number)}function s(n){return n[a(n)]}function a(n){return Math.max(0,n.length-1)}function d(n,t){return t===a(n)}function l(n,t=0){return Array.from(Array(n),((n,e)=>t+e))}function f(n){return Object.keys(n)}function p(n,t){return[n,t].reduce(((n,t)=>(f(t).forEach((e=>{const o=n[e],i=t[e],c=r(o)&&r(i);n[e]=c?p(o,i):i})),n)),{})}function m(n,t){return void 0!==t.MouseEvent&&n instanceof t.MouseEvent}function g(){let n=[];const t={add:function(e,r,o,i={passive:!0}){let c;if("addEventListener"in e)e.addEventListener(r,o,i),c=()=>e.removeEventListener(r,o,i);else{const n=e;n.addListener(o),c=()=>n.removeListener(o)}return n.push(c),t},clear:function(){n=n.filter((n=>n()))}};return t}function h(n,t,e,r){const o=g(),i=1e3/60;let c=null,u=0,s=0;function a(n){if(!s)return;c||(c=n,e(),e());const o=n-c;for(c=n,u+=o;u>=i;)e(),u-=i;r(u/i),s&&(s=t.requestAnimationFrame(a))}function d(){t.cancelAnimationFrame(s),c=null,u=0,s=0}return{init:function(){o.add(n,"visibilitychange",(()=>{n.hidden&&(c=null,u=0)}))},destroy:function(){d(),o.clear()},start:function(){s||(s=t.requestAnimationFrame(a))},stop:d,update:e,render:r}}function x(n=0,t=0){const e=o(n-t);function r(t){return t<n}function i(n){return n>t}function c(n){return r(n)||i(n)}return{length:e,max:t,min:n,constrain:function(e){return c(e)?r(e)?n:t:e},reachedAny:c,reachedMax:i,reachedMin:r,removeOffset:function(n){return e?n-e*Math.ceil((n-t)/e):n}}}function y(n,t,e){const{constrain:r}=x(0,n),i=n+1;let c=u(t);function u(n){return e?o((i+n)%i):r(n)}function s(){return c}function a(){return y(n,s(),e)}const d={get:s,set:function(n){return c=u(n),d},add:function(n){return a().set(s()+n)},clone:a};return d}function v(n,t,r,u,s,a,d,l,f,p,h,y,v,b,S,w,E,L,D){const{cross:I,direction:M}=n,A=["INPUT","SELECT","TEXTAREA"],F={passive:!1},T=g(),O=g(),P=x(50,225).constrain(b.measure(20)),z={mouse:300,touch:400},H={mouse:500,touch:600},k=S?43:25;let V=!1,B=0,C=0,N=!1,R=!1,j=!1,G=!1;function q(n){if(!m(n,u)&&n.touches.length>=2)return U(n);const t=a.readPoint(n),e=a.readPoint(n,I),r=c(t,B),o=c(e,C);if(!R&&!G){if(!n.cancelable)return U(n);if(R=r>o,!R)return U(n)}const i=a.pointerMove(n);r>w&&(j=!0),p.useFriction(.3).useDuration(.75),l.start(),s.add(M(i)),n.preventDefault()}function U(n){const t=h.byDistance(0,!1).index!==y.get(),e=a.pointerUp(n)*(S?H:z)[G?"mouse":"touch"],r=function(n,t){const e=y.add(-1*i(n)),r=h.byDistance(n,!S).distance;return S||o(n)<P?r:E&&t?.5*r:h.byIndex(e.get(),0).distance}(M(e),t),u=function(n,t){if(0===n||0===t)return 0;if(o(n)<=o(t))return 0;const e=c(o(n),o(t));return o(e/n)}(e,r),s=k-10*u,d=L+u/50;R=!1,N=!1,O.clear(),p.useDuration(s).useFriction(d),f.distance(r,!S),G=!1,v.emit("pointerUp")}function W(n){j&&(n.stopPropagation(),n.preventDefault(),j=!1)}return{init:function(n){if(!D)return;function o(o){(e(D)||D(n,o))&&function(n){const e=m(n,u);if(G=e,j=S&&e&&!n.buttons&&V,V=c(s.get(),d.get())>=2,e&&0!==n.button)return;if(function(n){const t=n.nodeName||"";return A.includes(t)}(n.target))return;N=!0,a.pointerDown(n),p.useFriction(0).useDuration(0),s.set(d),function(){const n=G?r:t;O.add(n,"touchmove",q,F).add(n,"touchend",U).add(n,"mousemove",q,F).add(n,"mouseup",U)}(),B=a.readPoint(n),C=a.readPoint(n,I),v.emit("pointerDown")}(o)}const i=t;T.add(i,"dragstart",(n=>n.preventDefault()),F).add(i,"touchmove",(()=>{}),F).add(i,"touchend",(()=>{})).add(i,"touchstart",o).add(i,"mousedown",o).add(i,"touchcancel",U).add(i,"contextmenu",U).add(i,"click",W,!0)},destroy:function(){T.clear(),O.clear()},pointerDown:function(){return N}}}function b(n,t){let e,r;function i(n){return n.timeStamp}function c(e,r){const o="client"+("x"===(r||n.scroll)?"X":"Y");return(m(e,t)?e:e.touches[0])[o]}return{pointerDown:function(n){return e=n,r=n,c(n)},pointerMove:function(n){const t=c(n)-c(r),o=i(n)-i(e)>170;return r=n,o&&(e=n),t},pointerUp:function(n){if(!e||!r)return 0;const t=c(r)-c(e),u=i(n)-i(e),s=i(n)-i(r)>170,a=t/u;return u&&!s&&o(a)>.1?a:0},readPoint:c}}function S(n,t,r,i,c,u,s){const a=[n].concat(i);let d,l,f=[],p=!1;function m(n){return c.measureSize(s.measure(n))}return{init:function(c){u&&(l=m(n),f=i.map(m),d=new ResizeObserver((r=>{(e(u)||u(c,r))&&function(e){for(const r of e){if(p)return;const e=r.target===n,u=i.indexOf(r.target),s=e?l:f[u];if(o(m(e?n:i[u])-s)>=.5){c.reInit(),t.emit("resize");break}}}(r)})),r.requestAnimationFrame((()=>{a.forEach((n=>d.observe(n)))})))},destroy:function(){p=!0,d&&d.disconnect()}}}function w(n,t,e,r,i){const c=i.measure(10),u=i.measure(50),s=x(.1,.99);let a=!1;function d(){return!a&&(!!n.reachedAny(e.get())&&!!n.reachedAny(t.get()))}return{shouldConstrain:d,constrain:function(i){if(!d())return;const a=n.reachedMin(t.get())?"min":"max",l=o(n[a]-t.get()),f=e.get()-t.get(),p=s.constrain(l/u);e.subtract(f*p),!i&&o(f)<c&&(e.set(n.constrain(e.get())),r.useDuration(25).useBaseFriction())},toggleActive:function(n){a=!n}}}function E(n,t,e,r){const o=t.min+.1,i=t.max+.1,{reachedMin:c,reachedMax:u}=x(o,i);return{loop:function(t){if(!function(n){return 1===n?u(e.get()):-1===n&&c(e.get())}(t))return;const o=n*(-1*t);r.forEach((n=>n.add(o)))}}}function L(n,t,e,r,c){const{reachedAny:u,removeOffset:a,constrain:d}=r;function l(n){return n.concat().sort(((n,t)=>o(n)-o(t)))[0]}function f(t,r){const o=[t,t+e,t-e];if(!n)return t;if(!r)return l(o);const c=o.filter((n=>i(n)===r));return c.length?l(c):s(o)-e}return{byDistance:function(e,r){const i=c.get()+e,{index:s,distance:l}=function(e){const r=n?a(e):d(e),i=t.map(((n,t)=>({diff:f(n-r,0),index:t}))).sort(((n,t)=>o(n.diff)-o(t.diff))),{index:c}=i[0];return{index:c,distance:r}}(i),p=!n&&u(i);return!r||p?{index:s,distance:e}:{index:s,distance:e+f(t[s]-l,0)}},byIndex:function(n,e){return{index:n,distance:f(t[n]-c.get(),e)}},shortcut:f}}function D(t,r,o,i,c,u,s,a){const d={passive:!0,capture:!0};let l=0;function f(n){"Tab"===n.code&&(l=(new Date).getTime())}return{init:function(p){a&&(u.add(document,"keydown",f,!1),r.forEach(((r,f)=>{u.add(r,"focus",(r=>{(e(a)||a(p,r))&&function(e){if((new Date).getTime()-l>10)return;s.emit("slideFocusStart"),t.scrollLeft=0;const r=o.findIndex((n=>n.includes(e)));n(r)&&(c.useDuration(0),i.index(r,0),s.emit("slideFocus"))}(f)}),d)})))}}}function I(t){let e=t;function r(t){return n(t)?t:t.get()}return{get:function(){return e},set:function(n){e=r(n)},add:function(n){e+=r(n)},subtract:function(n){e-=r(n)}}}function M(n,t){const e="x"===n.scroll?function(n){return`translate3d(${n}px,0px,0px)`}:function(n){return`translate3d(0px,${n}px,0px)`},r=t.style;let o=null,i=!1;return{clear:function(){i||(r.transform="",t.getAttribute("style")||t.removeAttribute("style"))},to:function(t){if(i)return;const c=(u=n.direction(t),Math.round(100*u)/100);var u;c!==o&&(r.transform=e(c),o=c)},toggleActive:function(n){i=!n}}}function A(n,t,e,r,o,i,c,s,a){const d=.5,l=u(o),f=u(o).reverse(),p=function(){const n=c[0];return h(g(f,n),e,!1)}().concat(function(){const n=t-c[0]-1;return h(g(l,n),-e,!0)}());function m(n,t){return n.reduce(((n,t)=>n-o[t]),t)}function g(n,t){return n.reduce(((n,e)=>m(n,t)>0?n.concat([e]):n),[])}function h(o,c,u){const l=function(n){return i.map(((e,o)=>({start:e-r[o]+d+n,end:e+t-d+n})))}(c);return o.map((t=>{const r=u?0:-e,o=u?e:0,i=u?"end":"start",c=l[t][i];return{index:t,loopPoint:c,slideLocation:I(-1),translate:M(n,a[t]),target:()=>s.get()>c?r:o}}))}return{canLoop:function(){return p.every((({index:n})=>m(l.filter((t=>t!==n)),t)<=.1))},clear:function(){p.forEach((n=>n.translate.clear()))},loop:function(){p.forEach((n=>{const{target:t,translate:e,slideLocation:r}=n,o=t();o!==r.get()&&(e.to(o),r.set(o))}))},loopPoints:p}}function F(n,t,r){let o,i=!1;return{init:function(c){r&&(o=new MutationObserver((n=>{i||(e(r)||r(c,n))&&function(n){for(const e of n)if("childList"===e.type){c.reInit(),t.emit("slidesChanged");break}}(n)})),o.observe(n,{childList:!0}))},destroy:function(){o&&o.disconnect(),i=!0}}}function T(n,t,e,r){const o={};let i,c=null,u=null,s=!1;return{init:function(){i=new IntersectionObserver((n=>{s||(n.forEach((n=>{const e=t.indexOf(n.target);o[e]=n})),c=null,u=null,e.emit("slidesInView"))}),{root:n.parentElement,threshold:r}),t.forEach((n=>i.observe(n)))},destroy:function(){i&&i.disconnect(),s=!0},get:function(n=!0){if(n&&c)return c;if(!n&&u)return u;const t=function(n){return f(o).reduce(((t,e)=>{const r=parseInt(e),{isIntersecting:i}=o[r];return(n&&i||!n&&!i)&&t.push(r),t}),[])}(n);return n&&(c=t),n||(u=t),t}}}function O(t,e,r,i,c,d,l,f,p){const{startEdge:m,endEdge:g,direction:h}=t,x=n(r);return{groupSlides:function(n){return x?function(n,t){return u(n).filter((n=>n%t==0)).map((e=>n.slice(e,e+t)))}(n,r):function(n){return n.length?u(n).reduce(((t,r,u)=>{const x=s(t)||0,y=0===x,v=r===a(n),b=c[m]-d[x][m],S=c[m]-d[r][g],w=!i&&y?h(l):0,E=o(S-(!i&&v?h(f):0)-(b+w));return u&&E>e+p&&t.push(r),v&&t.push(n.length),t}),[]).map(((t,e,r)=>{const o=Math.max(r[e-1]||0);return n.slice(o,t)})):[]}(n)}}}function P(n,e,r,f,p,m,P){const{align:z,axis:H,direction:k,startIndex:V,loop:B,duration:C,dragFree:N,dragThreshold:R,inViewThreshold:j,slidesToScroll:G,skipSnaps:q,containScroll:U,watchResize:W,watchSlides:$,watchDrag:Q,watchFocus:X}=m,Y={measure:function(n){const{offsetTop:t,offsetLeft:e,offsetWidth:r,offsetHeight:o}=n;return{top:t,right:e+r,bottom:t+o,left:e,width:r,height:o}}},J=Y.measure(e),K=r.map(Y.measure),Z=function(n,t){const e="rtl"===t,r="y"===n,o=!r&&e?-1:1;return{scroll:r?"y":"x",cross:r?"x":"y",startEdge:r?"top":e?"right":"left",endEdge:r?"bottom":e?"left":"right",measureSize:function(n){const{height:t,width:e}=n;return r?t:e},direction:function(n){return n*o}}}(H,k),_=Z.measureSize(J),nn=function(n){return{measure:function(t){return n*(t/100)}}}(_),tn=function(n,e){const r={start:function(){return 0},center:function(n){return o(n)/2},end:o};function o(n){return e-n}return{measure:function(o,i){return t(n)?r[n](o):n(e,o,i)}}}(z,_),en=!B&&!!U,rn=B||!!U,{slideSizes:on,slideSizesWithGaps:cn,startGap:un,endGap:sn}=function(n,t,e,r,i,c){const{measureSize:u,startEdge:a,endEdge:l}=n,f=e[0]&&i,p=function(){if(!f)return 0;const n=e[0];return o(t[a]-n[a])}(),m=function(){if(!f)return 0;const n=c.getComputedStyle(s(r));return parseFloat(n.getPropertyValue(`margin-${l}`))}(),g=e.map(u),h=e.map(((n,t,e)=>{const r=!t,o=d(e,t);return r?g[t]+p:o?g[t]+m:e[t+1][a]-n[a]})).map(o);return{slideSizes:g,slideSizesWithGaps:h,startGap:p,endGap:m}}(Z,J,K,r,rn,p),an=O(Z,_,G,B,J,K,un,sn,2),{snaps:dn,snapsAligned:ln}=function(n,t,e,r,i){const{startEdge:c,endEdge:u}=n,{groupSlides:a}=i,d=a(r).map((n=>s(n)[u]-n[0][c])).map(o).map(t.measure),l=r.map((n=>e[c]-n[c])).map((n=>-o(n))),f=a(l).map((n=>n[0])).map(((n,t)=>n+d[t]));return{snaps:l,snapsAligned:f}}(Z,tn,J,K,an),fn=-s(dn)+s(cn),{snapsContained:pn,scrollContainLimit:mn}=function(n,t,e,r,o){const i=x(-t+n,0),u=e.map(((n,t)=>{const{min:r,max:o}=i,c=i.constrain(n),u=!t,s=d(e,t);return u?o:s||l(r,c)?r:l(o,c)?o:c})).map((n=>parseFloat(n.toFixed(3)))),a=function(){const n=u[0],t=s(u);return x(u.lastIndexOf(n),u.indexOf(t)+1)}();function l(n,t){return c(n,t)<=1}return{snapsContained:function(){if(t<=n+o)return[i.max];if("keepSnaps"===r)return u;const{min:e,max:c}=a;return u.slice(e,c)}(),scrollContainLimit:a}}(_,fn,ln,U,2),gn=en?pn:ln,{limit:hn}=function(n,t,e){const r=t[0];return{limit:x(e?r-n:s(t),r)}}(fn,gn,B),xn=y(a(gn),V,B),yn=xn.clone(),vn=u(r),bn=h(f,p,(()=>(({dragHandler:n,scrollBody:t,scrollBounds:e,options:{loop:r}})=>{r||e.constrain(n.pointerDown()),t.seek()})(Hn)),(n=>(({scrollBody:n,translate:t,location:e,offsetLocation:r,previousLocation:o,scrollLooper:i,slideLooper:c,dragHandler:u,animation:s,eventHandler:a,scrollBounds:d,options:{loop:l}},f)=>{const p=n.settled(),m=!d.shouldConstrain(),g=l?p:p&&m,h=g&&!u.pointerDown();h&&s.stop();const x=e.get()*f+o.get()*(1-f);r.set(x),l&&(i.loop(n.direction()),c.loop()),t.to(r.get()),h&&a.emit("settle"),g||a.emit("scroll")})(Hn,n))),Sn=gn[xn.get()],wn=I(Sn),En=I(Sn),Ln=I(Sn),Dn=I(Sn),In=function(n,t,e,r,c,u){let s=0,a=0,d=c,l=u,f=n.get(),p=0;function m(n){return d=n,h}function g(n){return l=n,h}const h={direction:function(){return a},duration:function(){return d},velocity:function(){return s},seek:function(){const t=r.get()-n.get();let o=0;return d?(e.set(n),s+=t/d,s*=l,f+=s,n.add(s),o=f-p):(s=0,e.set(r),n.set(r),o=t),a=i(o),p=f,h},settled:function(){return o(r.get()-t.get())<.001},useBaseFriction:function(){return g(u)},useBaseDuration:function(){return m(c)},useFriction:g,useDuration:m};return h}(wn,Ln,En,Dn,C,.68),Mn=L(B,gn,fn,hn,Dn),An=function(n,t,e,r,o,i,c){function u(o){const u=o.distance,s=o.index!==t.get();i.add(u),u&&(r.duration()?n.start():(n.update(),n.render(1),n.update())),s&&(e.set(t.get()),t.set(o.index),c.emit("select"))}return{distance:function(n,t){u(o.byDistance(n,t))},index:function(n,e){const r=t.clone().set(n);u(o.byIndex(r.get(),e))}}}(bn,xn,yn,In,Mn,Dn,P),Fn=function(n){const{max:t,length:e}=n;return{get:function(n){return e?(n-t)/-e:0}}}(hn),Tn=g(),On=T(e,r,P,j),{slideRegistry:Pn}=function(n,t,e,r,o,i){const{groupSlides:c}=o,{min:u,max:f}=r;return{slideRegistry:function(){const r=c(i),o=!n||"keepSnaps"===t;return 1===e.length?[i]:o?r:r.slice(u,f).map(((n,t,e)=>{const r=!t,o=d(e,t);return r?l(s(e[0])+1):o?l(a(i)-s(e)[0]+1,s(e)[0]):n}))}()}}(en,U,gn,mn,an,vn),zn=D(n,r,Pn,An,In,Tn,P,X),Hn={ownerDocument:f,ownerWindow:p,eventHandler:P,containerRect:J,slideRects:K,animation:bn,axis:Z,dragHandler:v(Z,n,f,p,Dn,b(Z,p),wn,bn,An,In,Mn,xn,P,nn,N,R,q,.68,Q),eventStore:Tn,percentOfView:nn,index:xn,indexPrevious:yn,limit:hn,location:wn,offsetLocation:Ln,previousLocation:En,options:m,resizeHandler:S(e,P,p,r,Z,W,Y),scrollBody:In,scrollBounds:w(hn,Ln,Dn,In,nn),scrollLooper:E(fn,hn,Ln,[wn,Ln,En,Dn]),scrollProgress:Fn,scrollSnapList:gn.map(Fn.get),scrollSnaps:gn,scrollTarget:Mn,scrollTo:An,slideLooper:A(Z,_,fn,on,cn,dn,gn,Ln,r),slideFocus:zn,slidesHandler:F(e,P,$),slidesInView:On,slideIndexes:vn,slideRegistry:Pn,slidesToScroll:an,target:Dn,translate:M(Z,e)};return Hn}const z={align:"center",axis:"x",container:null,slides:null,containScroll:"trimSnaps",direction:"ltr",slidesToScroll:1,inViewThreshold:0,breakpoints:{},dragFree:!1,dragThreshold:10,loop:!1,skipSnaps:!1,duration:25,startIndex:0,active:!0,watchDrag:!0,watchResize:!0,watchSlides:!0,watchFocus:!0};function H(n){function t(n,t){return p(n,t||{})}const e={mergeOptions:t,optionsAtMedia:function(e){const r=e.breakpoints||{},o=f(r).filter((t=>n.matchMedia(t).matches)).map((n=>r[n])).reduce(((n,e)=>t(n,e)),{});return t(e,o)},optionsMediaQueries:function(t){return t.map((n=>f(n.breakpoints||{}))).reduce(((n,t)=>n.concat(t)),[]).map(n.matchMedia)}};return e}function k(n,e,r){const o=n.ownerDocument,i=o.defaultView,c=H(i),u=function(n){let t=[];return{init:function(e,r){return t=r.filter((({options:t})=>!1!==n.optionsAtMedia(t).active)),t.forEach((t=>t.init(e,n))),r.reduce(((n,t)=>Object.assign(n,{[t.name]:t})),{})},destroy:function(){t=t.filter((n=>n.destroy()))}}}(c),s=g(),a=function(){let n,t={};function e(n){return t[n]||[]}const r={init:function(t){n=t},emit:function(t){return e(t).forEach((e=>e(n,t))),r},off:function(n,o){return t[n]=e(n).filter((n=>n!==o)),r},on:function(n,o){return t[n]=e(n).concat([o]),r},clear:function(){t={}}};return r}(),{mergeOptions:d,optionsAtMedia:l,optionsMediaQueries:f}=c,{on:p,off:m,emit:h}=a,x=A;let y,v,b,S,w=!1,E=d(z,k.globalOptions),L=d(E),D=[];function I(t){const e=P(n,b,S,o,i,t,a);if(t.loop&&!e.slideLooper.canLoop()){return I(Object.assign({},t,{loop:!1}))}return e}function M(e,r){w||(E=d(E,e),L=l(E),D=r||D,function(){const{container:e,slides:r}=L,o=t(e)?n.querySelector(e):e;b=o||n.children[0];const i=t(r)?b.querySelectorAll(r):r;S=[].slice.call(i||b.children)}(),y=I(L),f([E,...D.map((({options:n})=>n))]).forEach((n=>s.add(n,"change",A))),L.active&&(y.translate.to(y.location.get()),y.animation.init(),y.slidesInView.init(),y.slideFocus.init(V),y.eventHandler.init(V),y.resizeHandler.init(V),y.slidesHandler.init(V),y.options.loop&&y.slideLooper.loop(),b.offsetParent&&S.length&&y.dragHandler.init(V),v=u.init(V,D)))}function A(n,t){const e=O();F(),M(d({startIndex:e},n),t),a.emit("reInit")}function F(){y.dragHandler.destroy(),y.eventStore.clear(),y.translate.clear(),y.slideLooper.clear(),y.resizeHandler.destroy(),y.slidesHandler.destroy(),y.slidesInView.destroy(),y.animation.destroy(),u.destroy(),s.clear()}function T(n,t,e){L.active&&!w&&(y.scrollBody.useBaseFriction().useDuration(!0===t?0:L.duration),y.scrollTo.index(n,e||0))}function O(){return y.index.get()}const V={canScrollNext:function(){return y.index.add(1).get()!==O()},canScrollPrev:function(){return y.index.add(-1).get()!==O()},containerNode:function(){return b},internalEngine:function(){return y},destroy:function(){w||(w=!0,s.clear(),F(),a.emit("destroy"),a.clear())},off:m,on:p,emit:h,plugins:function(){return v},previousScrollSnap:function(){return y.indexPrevious.get()},reInit:x,rootNode:function(){return n},scrollNext:function(n){T(y.index.add(1).get(),n,-1)},scrollPrev:function(n){T(y.index.add(-1).get(),n,1)},scrollProgress:function(){return y.scrollProgress.get(y.offsetLocation.get())},scrollSnapList:function(){return y.scrollSnapList},scrollTo:T,selectedScrollSnap:O,slideNodes:function(){return S},slidesInView:function(){return y.slidesInView.get()},slidesNotInView:function(){return y.slidesInView.get(!1)}};return M(e,r),setTimeout((()=>a.emit("init")),0),V}return k.globalOptions=void 0,k}));

/**
 * Embla Carousel Fade
 */
!function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).EmblaCarouselFade=t()}(this,(function(){"use strict";function n(n,t,e){return Math.min(Math.max(n,t),e)}function t(n){return"number"==typeof n&&!isNaN(n)}function e(e={}){const o=1,i=0,r=.68;let s,l,c,a,f=[],d=0,u=0,p=0,g=!1;function y(){b(s.selectedScrollSnap(),o)}function E(){g=!1}function S(){g=!1,d=0,u=0}function h(){const n=s.internalEngine().scrollBody.duration();u=n?0:o,g=!0,n||y()}function m(n){const{scrollSnaps:e,location:o,target:i}=s.internalEngine();!t(n)||f[n]<.5||(o.set(e[n]),i.set(o))}function b(t,e){s.scrollSnapList().forEach(((r,l)=>{const c=Math.abs(e),a=f[l],u=l===t,y=n(u?a+c:a-c,i,o);f[l]=y;const E=u&&g,S=s.previousScrollSnap();E&&(f[S]=1-y),u&&function(n,t){const{index:e,dragHandler:o,scrollSnaps:i}=s.internalEngine(),r=o.pointerDown(),l=1/(i.length-1);let c=n,a=r?s.selectedScrollSnap():s.previousScrollSnap();if(r&&c===a){const n=-1*Math.sign(d);c=a,a=e.clone().set(a).add(n).get()}const f=a*l,u=(c-a)*l;p=f+u*t}(t,y),function(n){const t=s.internalEngine().slideRegistry[n],{scrollSnaps:e,containerRect:o}=s.internalEngine(),r=f[n];t.forEach((t=>{const l=s.slideNodes()[t].style,c=parseFloat(r.toFixed(2)),a=c>i,f=function(n){const{axis:t}=s.internalEngine();return`translate${t.scroll.toUpperCase()}(${t.direction(n)}px)`}(a?e[n]:o.width+2);a&&(l.transform=f),l.opacity=c.toString(),l.pointerEvents=r>.5?"auto":"none",a||(l.transform=f)}))}(l)}))}function v(){const{dragHandler:n,index:t,scrollBody:e}=s.internalEngine(),o=s.selectedScrollSnap();if(!n.pointerDown())return o;const i=Math.sign(e.velocity()),r=Math.sign(d),l=t.clone().set(o).add(-1*i).get();return i&&r?r===i?l:o:null}function x(){const{target:n,location:e}=s.internalEngine(),i=n.get()-e.get(),c=Math.abs(i)>=1,a=v(),p=!t(a);return function(n){const{dragHandler:e,scrollBody:i}=n.internalEngine(),s=e.pointerDown(),c=i.velocity(),a=i.duration(),p=v(),g=!t(p);if(s){if(!c)return;d+=c,u=Math.abs(c/l),m(p)}if(!s){if(!a||g)return;u+=(o-f[p])/a,u*=r}g||b(p,u)}(s),!p&&!c&&f[a]>.999}function M(){return p}return{name:"fade",options:e,init:function(t){s=t;const e=s.selectedScrollSnap(),{scrollBody:r,containerRect:d,axis:u}=s.internalEngine(),p=u.measureSize(d);l=n(.75*p,200,500),g=!1,f=s.scrollSnapList().map(((n,t)=>t===e?o:i)),c=r.settled,a=s.scrollProgress,r.settled=x,s.scrollProgress=M,s.on("select",h).on("slideFocus",y).on("pointerDown",S).on("pointerUp",E),function(){const{translate:n,slideLooper:t}=s.internalEngine();n.clear(),n.toggleActive(!1),t.loopPoints.forEach((({translate:n})=>{n.clear(),n.toggleActive(!1)}))}(),y()},destroy:function(){const{scrollBody:n}=s.internalEngine();n.settled=c,s.scrollProgress=a,s.off("select",h).off("slideFocus",y).off("pointerDown",S).off("pointerUp",E),s.slideNodes().forEach((n=>{const t=n.style;t.opacity="",t.transform="",t.pointerEvents="",n.getAttribute("style")||n.removeAttribute("style")}))}}}return e.globalOptions=void 0,e}));
window.LayoutHubSlider = (wrapper) => {
  const container = wrapper.querySelector(".lh-slider-container");
  if (!container || container.getAttribute("data-lh-slider-initialized") === "true") return;
  container.setAttribute("data-lh-slider-initialized", "true");
  // =====================
  // Local State
  // =====================
  let embla = null;
  let dots = [];
  let autoplayInterval = null;
  let autoplayTimeout = null;
  let autoplayDelay = 3000;
  let lastStartTime = null;
  let remainingTime = null;
  let boundEmblaNode = null;
  let progressValue = 0;
  let progressRAF = null;
  let isHovering = false;
  let stopAtEnd = false;
  // =====================
  // Utils
  // =====================
  function parseTransition(value) {
    if (!value) return 3000;
    value = value.trim();
    if (value.endsWith("ms")) return parseFloat(value);
    if (value.endsWith("s")) return parseFloat(value) * 1000;
    return parseFloat(value) * 1000;
  }
  function getItemsPerView(width, node) {
    const desktop = parseInt(node.getAttribute("data-item") || 1, 10);
    const tablet = parseInt(node.getAttribute("data-item-tablet") || 1, 10);
    const mobile = parseInt(node.getAttribute("data-item-mobile") || 1, 10);
    return width >= 1024 ? desktop : width >= 640 ? tablet : mobile;
  }
  function getPaginationViewWidth(node, defaultWidth = 80) {
    const raw = parseFloat(node.getAttribute("data-pagination-width"));
    return isNaN(raw) ? defaultWidth : raw;
  }
  function isSliderLayout(width, node) {
    const desktopLayout = node.getAttribute("data-desktop-layout");
    const tabletLayout = node.getAttribute("data-tablet-layout");
    const mobileLayout = node.getAttribute("data-mobile-layout");
  
    if (width >= 1024) {
      return desktopLayout === "slider";
    } else if (width >= 640) {
      const layout = tabletLayout || desktopLayout;
      return layout === "slider";
    } else {
      return mobileLayout === "slider";
    }
  }

  // =====================
  // Autoplay
  // =====================
  function resetProgress() {
    progressValue = 0;
    updateProgressBarUI(progressValue);
  }
  function animateProgressBar() {
    cancelAnimationFrame(progressRAF);
    const step = () => {
      if (!embla) return;
      const emblaNode = wrapper.querySelector(".lh-slider-wrapper");
      if (!emblaNode) return;
      const width = window.innerWidth;
      const isLoopEnabled = embla?.internalEngine()?.options?.loop;
      const selectedIndex = embla.selectedScrollSnap();
      const totalSlides = embla.slideNodes().length;
      const itemsPerView = getItemsPerView(width, emblaNode);
      const isAtLastSlide = selectedIndex >= totalSlides - itemsPerView;
      if (isHovering || stopAtEnd) {
        updateProgressBarUI(progressValue);
        progressRAF = requestAnimationFrame(step);
        return;
      }
      // time elapsed since last start
      const elapsed = Date.now() - lastStartTime;
      progressValue = Math.min(((elapsed) / autoplayDelay) * 100, 100);
      updateProgressBarUI(progressValue);
      if (elapsed >= autoplayDelay) {
        if (!isLoopEnabled && isAtLastSlide) {
          stopAtEnd = true;
          return;
        }
        embla?.scrollNext();
        lastStartTime = Date.now();
        progressValue = 0;
      }
      progressRAF = requestAnimationFrame(step);
    };

    progressRAF = requestAnimationFrame(step);
  }
  function updateProgressBarUI(value) {
    const emblaNode = wrapper.querySelector(".lh-slider-wrapper");
    const controls = wrapper.querySelector(".lh-slider-controls");
    if (!emblaNode || !controls) return;
    const autoplayEnabled = emblaNode.getAttribute("data-play") === "true";
    controls.style.setProperty("--progress", autoplayEnabled ? `${value}` : "100");
  }
  function startAutoplay() {
    clearTimeout(autoplayTimeout);
    cancelAnimationFrame(progressRAF);
    lastStartTime = Date.now();
    progressValue = 0;
    stopAtEnd = false;
    animateProgressBar();
  }
  function pauseAutoplay() {
    clearTimeout(autoplayTimeout);
    cancelAnimationFrame(progressRAF);
    if (lastStartTime) {
      const elapsed = Date.now() - lastStartTime;
      remainingTime = Math.max(autoplayDelay - elapsed, 0);
      progressValue = (elapsed / autoplayDelay) * 100; 
    }
  }
  function resumeAutoplay() {
    clearTimeout(autoplayTimeout);
    cancelAnimationFrame(progressRAF);
    if (remainingTime != null) {
      lastStartTime = Date.now() - (autoplayDelay - remainingTime);
    } else {
      lastStartTime = Date.now();
    }
    animateProgressBar();
  }
  function setupAutoplay(node, autoplay, delay) {
    if (boundEmblaNode) {
      boundEmblaNode.removeEventListener("mouseenter", onMouseEnterPause);
      boundEmblaNode.removeEventListener("mouseleave", onMouseLeaveResume);
      boundEmblaNode = null;
    }
    pauseAutoplay();
    cancelAnimationFrame(progressRAF);
    autoplayDelay = delay;
    progressValue = 0;
    stopAtEnd = false;
    if (autoplay && node) {
      startAutoplay();
      node.addEventListener("mouseenter", onMouseEnterPause);
      node.addEventListener("mouseleave", onMouseLeaveResume);
      boundEmblaNode = node;
    }
  }
  function onMouseEnterPause() {
    isHovering = true;
    pauseAutoplay();
  }
  function onMouseLeaveResume() {
    isHovering = false;
    if (!stopAtEnd) {
      resumeAutoplay();
    }
  }

  // =====================
  // UI Helpers
  // =====================
  function updateSlideActive(itemsPerView, isFade) {
    if (!embla) return;
    const slides = embla.slideNodes();
    const totalSlides = slides.length;
    const selectedIndex = embla.selectedScrollSnap();
    const isLoop = embla.internalEngine().options.loop;
    slides.forEach((slide, index) => {
      slide.classList.remove("active", "active-prev", "active-next","active-main");
    });
    slides[selectedIndex]?.classList.add("active-main");
    if (isFade) {
      const currentSlide = slides[selectedIndex];
      if (currentSlide) {
        currentSlide.classList.add("active");
      }
      const prevIndex = (selectedIndex - 1 + totalSlides) % totalSlides;
      const nextIndex = (selectedIndex + 1) % totalSlides;
      slides[prevIndex]?.classList.add("active-prev");
      slides[nextIndex]?.classList.add("active-next");
    } else {
      const activeIndexes = Array.from({ length: itemsPerView }, (_, i) =>
        isLoop
          ? (selectedIndex + i) % totalSlides
          : selectedIndex + i
      );
      const prevIndex = isLoop
        ? (selectedIndex - 1 + totalSlides) % totalSlides
        : selectedIndex - 1;
      const nextIndex = isLoop
        ? (selectedIndex + itemsPerView) % totalSlides
        : selectedIndex + itemsPerView;
      slides.forEach((slide, index) => {
        if (activeIndexes.includes(index)) {
          slide.classList.add("active");
        } else if (index === prevIndex) {
          slide.classList.add("active-prev");
        } else if (index === nextIndex) {
          slide.classList.add("active-next");
        }
      });
    }
  }

  function createPagination(wrapper, emblaNode, paginationType, totalPages) {
    const paginationWrapper = wrapper.querySelector(".lh-slider-pagination-wrapper");
    if (!paginationWrapper) return { dotsArr: [], paginationWrapperInner: null };
    paginationWrapper.innerHTML = "";
    let paginationWrapperInner = null;
    let dotsArr = [];
    const enableSvg = paginationWrapper.dataset.paginationSvg === "true";
    const appendSvgToDot = (dot) => {
      if (!(paginationType === "dots" || paginationType === "numbers")) return;
      if (!enableSvg) return;
      if (dot.querySelector(".circular-progress")) return;
  
      const svgNS = "http://www.w3.org/2000/svg";
      const svg = document.createElementNS(svgNS, "svg");
      svg.setAttribute("class", "circular-progress");
      svg.setAttribute("aria-hidden", "true");
      svg.style.pointerEvents = "none";
  
      const bg = document.createElementNS(svgNS, "circle");
      bg.setAttribute("cx", "50");
      bg.setAttribute("cy", "50");
      bg.setAttribute("r", "45");
      bg.setAttribute("class", "circular-progress__bg");
  
      const fg = document.createElementNS(svgNS, "circle");
      fg.setAttribute("cx", "50");
      fg.setAttribute("cy", "50");
      fg.setAttribute("r", "45");
      fg.setAttribute("class", "circular-progress__fg");
  
      svg.appendChild(bg);
      svg.appendChild(fg);
      dot.appendChild(svg);
    };
    if (paginationType === "dynamic-dots") {
      const VIEW_WIDTH = getPaginationViewWidth(emblaNode);
      paginationWrapper.style.position = "relative";
      paginationWrapper.style.overflow = "hidden";
      paginationWrapper.style.width = `${VIEW_WIDTH}px`;
      paginationWrapperInner = document.createElement("div");
      paginationWrapperInner.classList.add("w-full", "pagination-bullets-dynamic");
      paginationWrapperInner.style.display = "flex";
      paginationWrapperInner.style.position = "relative";
      paginationWrapperInner.style.transition = "left 0.3s ease";
      paginationWrapper.appendChild(paginationWrapperInner);
      dotsArr = Array.from({ length: totalPages }, (_, i) => {
        const dot = document.createElement("span");
        dot.className = "lh-slider-pagination";
        dot.addEventListener("click", () => embla.scrollTo(i));
        paginationWrapperInner.appendChild(dot);
        return dot;
      });
    } else {
      paginationWrapper.style.width = "auto";
      dotsArr = Array.from({ length: totalPages }, (_, i) => {
        const dot = document.createElement("span");
        dot.className = "lh-slider-pagination";
        if (paginationType === "numbers") dot.textContent = i + 1;
        dot.addEventListener("click", () => embla.scrollTo(i));
        paginationWrapper.appendChild(dot);
        appendSvgToDot(dot);
        return dot;
      });
    }
    return { dotsArr, paginationWrapperInner };
  }
  function updateProgress(wrapper, selectedIndex, totalPages) {
    const progressWrapper = wrapper.querySelector(".lh-slider-pagination-progress");
    if (!progressWrapper) return;
    const progressEl = progressWrapper.querySelector("span");
    if (!progressEl) return;
    const type = progressWrapper.getAttribute("data-progress") || "grow";
    const stepPercent = 100 / totalPages;
    if (type === "slider") {
      progressEl.style.width = `${stepPercent}%`;
      progressEl.style.left = `${selectedIndex * stepPercent}%`;
    } else {
      const percent = ((selectedIndex + 1) / totalPages) * 100;
      progressEl.style.width = `${percent}%`;
      progressEl.style.left = "0";
    }
  }
  // =====================
  // Main Init
  // =====================
  function initSlider() {
    const emblaNode = wrapper.querySelector(".lh-slider-wrapper");
    if (!emblaNode) return;
    const width = window.innerWidth;
    // Non-slider layout
    if (!isSliderLayout(width, emblaNode)) {
      embla?.destroy();
      embla = null;
      wrapper.querySelector(".lh-slider-pagination-wrapper")?.replaceChildren();
      const controls = wrapper.querySelector(".lh-slider-controls");
      controls?.removeAttribute("show-desktop");
      controls?.removeAttribute("show-tablet");
      controls?.removeAttribute("show-mobile");
      setupAutoplay(null, false, 3000);
      return;
    }
    // Config
    const slidesToScrollRaw = parseInt(emblaNode.getAttribute("data-scroll") || "1", 10);
    const alignValue = emblaNode.getAttribute("data-align") || "start";
    const paginationType = emblaNode.getAttribute("data-pagination") || "dots";
    const autoplay = emblaNode.getAttribute("data-play") === "true";
    const transition = parseTransition(emblaNode.getAttribute("data-transition"));
    const effect = emblaNode.getAttribute("data-effect") || "slide";
    const isFade = effect === "fade";
    let itemsPerView = getItemsPerView(width, emblaNode);
    const slidesToScroll = isFade ? 1 : Math.min(slidesToScrollRaw, itemsPerView);
    const totalItems = emblaNode.querySelectorAll(".lh-slide-item").length;
    let isLoop = emblaNode.getAttribute("data-loop") === "true";
    if (totalItems <= itemsPerView) {
      isLoop = false;
    }
    emblaNode.setAttribute("data-init-loop", isLoop);
    // Init Embla
    embla?.destroy();
    embla = EmblaCarousel(
      emblaNode,
      {
        loop: isLoop,
        slidesToScroll,
        draggable: !isFade,
        dragFree: false,
        containScroll: isFade ? false : "trimSnaps",
        align: alignValue,
      },
      isFade ? [EmblaCarouselFade()] : []
    );
    wrapper.embla = embla;
    // Direction attribute
    let lastIndex = embla.selectedScrollSnap();
    embla.on("select", () => {
      const selectedIndex = embla.selectedScrollSnap();
      const totalSlides = embla.slideNodes().length;
      const width = window.innerWidth;
      const itemsPerView = getItemsPerView(width, emblaNode);
      emblaNode.setAttribute("data-dir", selectedIndex > lastIndex ? "left" : "right");
      if (stopAtEnd && selectedIndex < totalSlides - itemsPerView) {
        stopAtEnd = false;
        resumeAutoplay();
        animateProgressBar();
      }
      remainingTime = autoplayDelay;
      lastStartTime = Date.now();
      lastIndex = selectedIndex;
      resetProgress();
    });
    // Pagination
    if (isFade) itemsPerView = 1;
    const getTotalPages = () => embla.scrollSnapList().length;
    let { dotsArr, paginationWrapperInner } = createPagination(wrapper, emblaNode, paginationType, getTotalPages());
    dots = dotsArr;
    // Update UI
    function updateUI() {
      const selectedIndex = embla.selectedScrollSnap();
      const totalPages = getTotalPages();
      const dots = wrapper.querySelectorAll(".lh-slider-pagination");
      const paginationTotalEl = wrapper.querySelector(".lh-slider-pagination-total span");
      if (paginationTotalEl) paginationTotalEl.textContent = `${selectedIndex + 1}/${totalPages}`;
      dots.forEach((dot, i) => {
        dot.className = "lh-slider-pagination";
        if (i === selectedIndex) dot.classList.add("active");
        else if (i === selectedIndex - 1) dot.classList.add("prev");
        else if (i === selectedIndex - 2) dot.classList.add("prev-prev");
        else if (i === selectedIndex + 1) dot.classList.add("next");
        else if (i === selectedIndex + 2) dot.classList.add("next-next");
      });
      updateProgress(wrapper, selectedIndex, totalPages);
      // Dynamic dots move
      if (paginationType === "dynamic-dots" && paginationWrapperInner) {
        const realDots = wrapper.querySelectorAll(".lh-slider-pagination");
        if (!realDots) return;
        const style = getComputedStyle(realDots[0]);
        const DOT_SIZE = parseFloat(style.width) || 0;
        const DOT_MARGIN = parseFloat(style.marginLeft) || 0;
        const DOT_FULL = DOT_SIZE + DOT_MARGIN * 2;
        const baseOffset = DOT_FULL * 2;
        const offset = baseOffset - selectedIndex * DOT_FULL;
        realDots.forEach(dot => {
          dot.style.left = `${offset}px`;
        });
      }
      // Controls visibility
      const controls = wrapper.querySelector(".lh-slider-controls");
      setTimeout(() => {
        if (controls) {
          controls.removeAttribute("show-desktop");
          controls.removeAttribute("show-tablet");
          controls.removeAttribute("show-mobile");
          if (width >= 1024 && totalItems > getItemsPerView(1024, emblaNode)) {
            controls.setAttribute("show-desktop", "true");
          } else if (width >= 640 && width <= 1023 && totalItems > getItemsPerView(640, emblaNode)) {
            controls.setAttribute("show-tablet", "true");
          } else if (width <= 767 && totalItems > getItemsPerView(375, emblaNode)) {
            controls.setAttribute("show-mobile", "true");
          }
          if (controls) {
            controls.style.setProperty("--height-controls", `${controls.offsetHeight}px`);
          }
        }
      }, 100);
      const btnPrev = wrapper.querySelector(".lh-slider-nav-left");
      const btnNext = wrapper.querySelector(".lh-slider-nav-right");
      if (btnPrev) {
        btnPrev.disabled = !embla.canScrollPrev();
        btnPrev.classList.toggle("disabled", !embla.canScrollPrev());
      }
      if (btnNext) {
        btnNext.disabled = !embla.canScrollNext();
        btnNext.classList.toggle("disabled", !embla.canScrollNext());
      }
      updateSlideActive(itemsPerView, isFade);
    }
    wrapper.querySelector(".lh-slider-nav-left")?.addEventListener("click", embla.scrollPrev);
    wrapper.querySelector(".lh-slider-nav-right")?.addEventListener("click", embla.scrollNext);
    embla.on("select", updateUI);
    embla.on("reInit", () => {
      setupAutoplay(
        embla.containerNode(),
        embla.containerNode().getAttribute("data-play") === "true",
        parseTransition(embla.containerNode().getAttribute("data-transition"))
      );
      resetProgress();
      dots.forEach(dot => dot.removeEventListener("click", () => { }));
      dots = [];
      const result = createPagination(wrapper, emblaNode, paginationType, getTotalPages());
      dots = result.dotsArr;
      paginationWrapperInner = result.paginationWrapperInner;
      updateUI();
    });
    setupAutoplay(emblaNode, autoplay, transition);
    resetProgress();
    updateUI();
    if (wrapper.emblaThumb) {
      wrapper.emblaThumb.destroy();
      wrapper.emblaThumb = null;
    }
    // Thumbnails
    function initEmblaThumbs(wrapper) {
      const mediaProduct = wrapper.querySelector('.lh-media-product');
      const emblaThumbNode = wrapper.querySelector('.lh-product-thumb-slide');
      if (!emblaThumbNode) return;
      const viewportWidth = window.innerWidth;
      const isVertical =
        viewportWidth > 640 &&
        mediaProduct?.dataset.positionThumbs !== 'bottom';
      const OPTIONS_THUMBS = {
        dragFree: true,
        containScroll: 'keepSnaps',
        selectedClass: 'is-active',
        axis: isVertical ? 'y' : 'x',
      };
      if (wrapper.emblaThumb) {
        wrapper.emblaThumb.destroy();
        wrapper.emblaThumb = null;
      }
      const emblaThumb = EmblaCarousel(emblaThumbNode, OPTIONS_THUMBS);
      wrapper.emblaThumb = emblaThumb;
      const syncThumbs = () => {
        const index = wrapper.embla.selectedScrollSnap();
        emblaThumb.slideNodes().forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
        });
        emblaThumb.scrollTo(index);
      };
      wrapper.embla.on('select', syncThumbs);
      syncThumbs();
      emblaThumb.slideNodes().forEach((thumb, index) => {
        thumb.addEventListener('click', () => wrapper.embla.scrollTo(index));
      });
    }
    // --- Init
    initEmblaThumbs(wrapper);
    // --- Resize observer
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => initEmblaThumbs(wrapper), 300);
    });
    // --- Mutation observer
    const mediaProductEl = wrapper.querySelector('.lh-media-product');
    if (mediaProductEl) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'data-position-thumbs'
          ) {
            initEmblaThumbs(wrapper);
          }
        }
      });
      observer.observe(mediaProductEl, {
        attributes: true,
        attributeFilter: ['data-position-thumbs'],
      });
    }
    // Editor support
    function attachActivatedObserver(embla) {
      const items = embla.slideNodes();
      if (!items.length) return;
      const activatedObserver = new MutationObserver(mutationsList => {
        for (const mutation of mutationsList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "data-lh-block-activated"
          ) {
            const activatedItem = mutation.target;
            if (activatedItem.getAttribute("data-lh-block-activated") === "true") {
              const index = Array.from(items).indexOf(activatedItem);
              if (index !== -1) {
                embla.scrollTo(index, true)
              }
            }
          }
        }
      });
      items.forEach(item => {
        activatedObserver.observe(item, {
          attributes: true,
          attributeFilter: ["data-lh-block-activated"],
        });
      });
    }
    function observeItemReorder(embla, wrapper) {
      let debounceTimer = null;
      const reorderObserver = new MutationObserver(() => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          attachActivatedObserver(embla);
        }, 1000);
      });
      reorderObserver.observe(wrapper, {
        childList: true,
        subtree: true,
      });
    }
    attachActivatedObserver(embla);
    observeItemReorder(embla, embla.containerNode());
  }

  // =====================
  // Resize debounce
  // =====================
  let resizeTimeout;
  let lastWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const currentWidth = window.innerWidth;
      if (Math.abs(currentWidth - lastWidth) >= 100) {
        let hasActivated = emblaNodeObserver.querySelector('[data-lh-block-activated]');
        if (hasActivated) {
          setTimeout(() => {
            let activeItem = emblaNodeObserver.querySelector(".lh-slide-item.active");
            if (activeItem) {
              activeItem.click();
            }
          }, 50);
        }
        initSlider();
        lastWidth = currentWidth;
      }
    }, 100);
  });

  // =====================
  // Mutation observer for attrs
  // =====================
  const emblaNodeObserver = wrapper.querySelector(".lh-slider-wrapper");
  if (emblaNodeObserver) {
    const observer = new MutationObserver((mutations) => {
      if (
        mutations.some((m) =>
          [
            "data-loop", "data-effect", "data-align", "data-scroll",
            "data-pagination-width", "data-pagination",
            "data-item", "data-item-table", "data-item-mobile",
            "data-play", "data-transition",
            "data-desktop-layout", "data-mobile-layout",
            "data-position-thumbs"
          ].includes(m.attributeName)
        )
      ) {
        initSlider();
      }
    });
    observer.observe(emblaNodeObserver, { attributes: true });
  }
  initSlider();
};

try {
((wrapper, mode) => {})(document.querySelector('section.lh-2d4vay'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {})(document.querySelector('section.lh-65r960'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
setTimeout(() => {
  window.LayoutHubSlider(wrapper);
}, 50);

})(document.querySelector('section.lh-u0an7u'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
setTimeout(() => {
  window.LayoutHubSlider(wrapper);
}, 50);

})(document.querySelector('section.lh-p4oi0d'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
window.LayoutHubSlider(wrapper);

wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const url = this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  });
});


const syncGridAndHotspot = () => {
  const targetSelector = '.lh-grid-item';
  const hotspotSelector = '.lh-dots-with-image .lh-hotspot';
  const dotSelector = '.lh-slider-pagination-wrapper button';

  const activateHotspotByIndex = (index) => {
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) matchedHotspot.classList.add('active');
    markActiveItem();
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('active'));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add('active');
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
    }
    markActiveItem();
  };

  const markActiveItem = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('activeItem'));
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));

    const totalItems = wrapper.querySelectorAll(targetSelector).length;
    const activeItems = Array.from(wrapper.querySelectorAll(`${targetSelector}.active`));

    if (totalItems <= 2) {
      wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.add('active'));
      if (activeItems.length) {
        activeItems.forEach(item => item.classList.add('activeItem'));
      }
      return;
    }

    if (activeItems.length === 1) {
      activeItems[0].classList.add('activeItem');

      const index = activeItems[0].dataset.index;
      const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
      if (matchedHotspot) matchedHotspot.classList.add('active');
    } else if (activeItems.length > 1) {
      const indexes = activeItems.map(el => Number(el.dataset.index)).sort((a, b) => a - b);
      const firstIndex = indexes[0];
      const lastIndex = indexes[indexes.length - 1];

      let chosenIndex;
      if (firstIndex === 0 && lastIndex === totalItems - 1) {
        chosenIndex = lastIndex;
      } else {
        chosenIndex = firstIndex;
      }

      const chosenItem = activeItems.find(el => Number(el.dataset.index) === chosenIndex);
      if (chosenItem) {
        chosenItem.classList.add('activeItem');

        const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${chosenIndex}"]`);
        if (matchedHotspot) matchedHotspot.classList.add('active');
      }
    }
  };

  const setupGridClick = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => {
      item.addEventListener('click', () => {
        const index = item.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupHotspotClick = () => {
    wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = hotspot.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupDotClick = () => {
    wrapper.querySelectorAll(dotSelector).forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.index;
        if (index !== undefined) {
          activateItemByIndex(index);
          activateHotspotByIndex(index);
        }
      });
    });
  };

  const syncInitialState = () => {
    const activeItem = wrapper.querySelector(`${targetSelector}.active`);
    if (activeItem) {
      activateHotspotByIndex(activeItem.dataset.index);
    }
    markActiveItem();
  };

  if (wrapper.embla) {
    wrapper.embla.on('select', () => {
      markActiveItem();
    });
  }

  setupGridClick();
  setupHotspotClick();
  setupDotClick();
  syncInitialState();
};

syncGridAndHotspot();

if (mode != 'dev') {
  wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
  wrapper.querySelectorAll(".lh-rating-preview").forEach(function (el) {
    el.remove();
  });
} else {
  wrapper.querySelectorAll(".lh-rating-live").forEach(function (el) {
    el.remove();
  });
}


wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
  const productJsonEl = form.querySelector(".lh-product-json");
  const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
  if (!productJsonEl || !realSelect) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent || "{}");
  } catch (err) {
    console.error("Parse product JSON failed:", err);
    return;
  }
  if (!Array.isArray(productData.variants) || productData.variants.length === 0) return;

  const selects = form.querySelectorAll(".lh-custom-select");
  const updateVariant = () => {
    const selectedValues = Array.from(selects).map((sel) => {
      const txt = sel.querySelector(".selected-text");
      return txt ? txt.textContent.trim().toLowerCase() : "";
    });

    let matchedVariant = productData.variants.find((v) => {
      const opts = v.options.map((o) => (o ? o.trim().toLowerCase() : ""));
      return opts.every((optVal, i) => optVal === (selectedValues[i] || ""));
    });

    if (!matchedVariant) matchedVariant = productData.variants[0];
 
    realSelect.value = matchedVariant.id;
    realSelect.dispatchEvent(new Event("change", { bubbles: true }));
    
    selects.forEach((sel, i) => {
      const txt = sel.querySelector(".selected-text");
      const opts = sel.querySelectorAll(".lh-option");
      const newVal = matchedVariant.options[i] || "";
      if (txt) txt.textContent = newVal;

      opts.forEach((optEl) => {
        const inputEl = optEl.querySelector("input");
        const optValue = optEl.dataset.value?.trim().toLowerCase() || "";
        if (inputEl) inputEl.checked = optValue === newVal.trim().toLowerCase();
      });
    });
  };

wrapper.querySelectorAll(".lh-swatch-element input[type='radio']").forEach((inputEl) => {
  inputEl.addEventListener("change", (e) => {
    const form = e.target.closest("form.lh-product-box");
    if (!form) return;

    const selects = form.querySelectorAll(".lh-custom-select");
    const optionIndex = e.target.name.replace("option-", "");
    const value = e.target.value;

    const select = Array.from(selects).find(s => s.dataset.optionIndex === optionIndex);
    if (!select) return;

    const txt = select.querySelector(".selected-text");
    const preview = select.querySelector(".w-4.h-4.inline-block");
    const display = select.querySelector(".lh-select-display");

    if (txt) txt.textContent = value;
    if (display) display.setAttribute("aria-label", value);

    const colorKey = value.trim().toLowerCase().replace(/\s+/g, "-");
    if (preview) {
      const useImage = preview.style.backgroundImage.includes("url");
      if (useImage) {
        preview.style.backgroundImage = `var(--lh-swi-${colorKey})`;
      } else {
        preview.style.backgroundColor = `var(--lh-swc-${colorKey})`;
      }
    }

    const swatchWrapper = e.target.closest(".lh-custom-select");
    if (swatchWrapper) {
      const allSwatches = swatchWrapper.querySelectorAll(".lh-swatch-element");
      allSwatches.forEach(sw => sw.classList.remove("active"));
      const parentSw = e.target.closest(".lh-swatch-element");
      if (parentSw) parentSw.classList.add("active");
    }

    updateVariant();

    select.classList.remove("active");
  });
});

  selects.forEach((select) => {
    const display = select.querySelector(".lh-select-display");
    const optionsBox = select.querySelector(".lh-select-options");
    if (!display || !optionsBox) return;

    display.addEventListener("click", (e) => {
    e.stopPropagation();

    const isActive = select.classList.contains("active");

    // Toggle
    if (isActive) {
      select.classList.remove("active");
      optionsBox.classList.remove("open-up");
    } else {
      // Đóng tất cả select khác trước
      wrapper.querySelectorAll(".lh-custom-select.active").forEach((other) => {
        other.classList.remove("active");
        other.querySelector(".lh-select-options")?.classList.remove("open-up");
      });

      select.classList.add("active");

      const rect = optionsBox.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      if (spaceBelow < 100 && spaceAbove > spaceBelow) {
        optionsBox.classList.add("open-up");
      } else {
        optionsBox.classList.remove("open-up");
      }
    }
  });

  optionsBox.querySelectorAll(".lh-option").forEach((opt) => {
    opt.addEventListener("click", (e) => {
      e.stopPropagation();

      const input = opt.querySelector("input");
      if (input) input.checked = true;

      const value = opt.dataset.value || "";
      const txt = select.querySelector(".selected-text");
      const display = select.querySelector(".lh-select-display");
      if (txt) txt.textContent = value;
      if (display) display.setAttribute("aria-label", value);

      select.classList.remove("active");
      optionsBox.classList.remove("open-up");

      updateVariant();
    });
  });
});

wrapper.addEventListener("click", (e) => {
  wrapper.querySelectorAll(".lh-custom-select.active").forEach((sel) => {
    sel.classList.remove("active");
  });
});

  updateVariant();
});

function updateActiveSwatchBackground(select) {
  const display = select.querySelector(".lh-select-display");
  const displayLabel = display?.getAttribute("aria-label");
  const swatches = select.querySelectorAll(".lh-swatch-element");

  swatches.forEach(sw => {
    const input = sw.querySelector("input[type='radio']");
    const label = input?.getAttribute("aria-label");
    if (label && displayLabel && label.trim().toLowerCase() === displayLabel.trim().toLowerCase()) {
      sw.style.background = "#dfdfdfab";
      sw.style.color = "#181818 !important";
      sw.classList.add("active");
    } else {
      sw.style.background = "";
      sw.classList.remove("active");
    }
  });
}

const selects = wrapper.querySelectorAll(".lh-custom-select");

  selects.forEach(select => {
    const firstSwatch = select.querySelector('.lh-swatch-element[data-index="0"]');
    const firstInput = firstSwatch?.querySelector("input[type='radio']");
    const display = select.querySelector(".lh-select-display");

    if (firstSwatch && firstInput && display) {
      const firstLabel = firstInput.getAttribute("aria-label");
      display.setAttribute("aria-label", firstLabel);

      updateActiveSwatchBackground(select);
    }

    const swatches = select.querySelectorAll(".lh-swatch-element");
    swatches.forEach(sw => {
      const input = sw.querySelector("input[type='radio']");
      sw.addEventListener("click", () => {
        const label = input?.getAttribute("aria-label");
        if (label && display) {
          display.setAttribute("aria-label", label);
          updateActiveSwatchBackground(select);
        }
      });
    });
  });



if (mode != 'dev') {
  const bundleBtn = wrapper.querySelector("[data-product-bundle-submit]");
  const bundleMessage = wrapper.querySelector(".lh-error");

  const checkBundleAvailability = () => {
    if (!bundleBtn) return;
    let unavailable = false;

    wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (!variant || !variant.available || Number(variant.price) <= 0) {
        unavailable = true;
      }
    });

    if (unavailable) {
      bundleBtn.disabled = true;
      bundleBtn.classList.add("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "One or more products are sold out or have a price of 0.";
    } else {
      bundleBtn.disabled = false;
      bundleBtn.classList.remove("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "";
    }
  };

  wrapper.querySelectorAll("form.lh-product-box .lh-single-option-selector").forEach((select) => {
    select.addEventListener("change", checkBundleAvailability);
  });

  checkBundleAvailability();

  bundleBtn?.addEventListener("click", async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const spinner = btn.querySelector(".lh-loading__spinner");
    const textSpan = btn.querySelector(".btn-text");

    if (textSpan) textSpan.style.opacity = "0.4";
    spinner?.classList.remove("lh-hidden");
    if (bundleMessage) bundleMessage.textContent = "";

    const forms = wrapper.querySelectorAll("form.lh-product-box");
    const itemsToAdd = [];

    forms.forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const quantityInput = form.querySelector("input[name='quantity']") || { value: 1 };
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (variant && variant.available && Number(variant.price) > 0) {
        itemsToAdd.push({
          id: Number(realSelect.value),
          quantity: Number(quantityInput.value || 1),
        });
      }
    });

    if (itemsToAdd.length === 0) {
      spinner?.classList.add("lh-hidden");
      if (textSpan) textSpan.style.opacity = "1";
      return;
    }

    try {
      for (const item of itemsToAdd) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
      }
      window.location.href = "/cart"; 
    } catch (err) {
      if (bundleMessage) bundleMessage.textContent = "Failed to add bundle to cart.";
    }
  });
}

function reindexProductsAndLookbooks(wrapper) {
  const productItems = Array.from(wrapper.querySelectorAll('.lh-product-index')).filter(Boolean);
  const lookbookItems = Array.from(wrapper.querySelectorAll('.lh-lookbook-index')).filter(Boolean);

  productItems.forEach((item, index) => {
    item.dataset.index = index; 
  });

  lookbookItems.forEach((item, index) => {
    item.dataset.index = index;
  });

  console.log(`🔁 Reindexed: ${productItems.length} products, ${lookbookItems.length} lookbooks`);
}

reindexProductsAndLookbooks(wrapper);

const observerTarget =
  wrapper.querySelector('.lh-slider-container') ||
  wrapper.querySelector('.lh-grid') ||
  wrapper;

const observer = new MutationObserver((mutations) => {
  let shouldReindex = false;

  for (const mutation of mutations) {
    if (
      mutation.type === 'childList' &&
      ([...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) =>
          node.classList?.contains?.('lh-product-index') ||
          node.classList?.contains?.('lh-lookbook-index') ||
          node.querySelector?.('.lh-product-index') ||
          node.querySelector?.('.lh-lookbook-index')
      ))
    ) {
      shouldReindex = true;
      break;
    }
  }

  if (shouldReindex) {
    requestAnimationFrame(() => reindexProductsAndLookbooks(wrapper));
  }
});

observer.observe(observerTarget, {
  childList: true,
  subtree: true,
});






/* LayoutHub assets/lookbook.js */
const slideItems = wrapper.querySelectorAll(".lh-slide-item");
const hotspots = wrapper.querySelectorAll(".lh-hotspot");
const dotsWithImageEl = wrapper.querySelector(".lh-dots-with-image");
let currentIndex = 0;
let lastActiveIndex = Number(wrapper.dataset.lhLastActiveIndex) || 0;

function restoreLastActive() {
  requestAnimationFrame(() => {
    const targetSelector = ".lh-grid-item";
    const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${lastActiveIndex}"]`);
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${lastActiveIndex}"]`);
    if (matchedItem) matchedItem.classList.add("active");
    if (matchedHotspot) matchedHotspot.classList.add("active");
    if (wrapper.embla && !isNaN(lastActiveIndex)) wrapper.embla.scrollTo(Number(lastActiveIndex));
  });
}

const syncGridAndHotspotlook = () => {
  const targetSelector = ".lh-grid-item";
  const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
  const dotSelector = ".lh-slider-pagination-wrapper button";

  const activateHotspotByIndex = (index) => {

    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove("active"));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) {
      matchedHotspot.classList.add("active");
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove("active"));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add("active");
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  wrapper.querySelectorAll(targetSelector).forEach(item => {
    item.addEventListener("click", () => {
      const index = item.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  });

  wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
    hotspot.addEventListener("click", () => {
      const index = hotspot.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);

    });
  });

  wrapper.querySelectorAll(dotSelector).forEach(dot => {
    dot.addEventListener("click", () => {
      const index = dot.dataset.index;
      if (index !== undefined) {
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      }
    });
  });

  const activeItem = wrapper.querySelector(`${targetSelector}.active`);
  if (activeItem) activateHotspotByIndex(activeItem.dataset.index);

  if (wrapper.embla) {
    wrapper.embla.on("select", () => {
      const index = wrapper.embla.selectedScrollSnap();
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  }

  restoreLastActive();
  requestAnimationFrame(() => {
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  });
};
syncGridAndHotspotlook();

slideItems.forEach((slideItem, index) => {
  const hotspot = hotspots[index];
  if (!hotspot) return;
  const productPreview = hotspot.querySelector(".lh-product-preview");
  if (!productPreview) return;
  const updateClone = () => {
    const slideItemClone = slideItem.cloneNode(true);
    productPreview.innerHTML = "";
    productPreview.append(slideItemClone);
    if (mode === "dev") {
      slideItemClone.querySelectorAll("a").forEach(a => {
        a.removeAttribute("href");
        a.addEventListener("click", e => e.preventDefault());
        a.style.cursor = "default";
      });
    }

    restoreLastActive();
    requestAnimationFrame(() => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  };
  updateClone();
  const observer = new MutationObserver(updateClone);
  observer.observe(slideItem, {
    attributes: true,
    attributeFilter: ["class", "style"],
    childList: true,
    subtree: true
  });
});

function adjustPreviewDirection(tooltip, hotspot) {
  if (!tooltip || !hotspot || !dotsWithImageEl) return;

  const minOffset = Number(hotspot.getAttribute("data-tooltip-min-offset")) || 10;
  const gap = 8;
  const containerRect = dotsWithImageEl.getBoundingClientRect();

  const comp = window.getComputedStyle(tooltip);
  const wasHidden =
    comp.display === "none" ||
    comp.visibility === "hidden" ||
    parseFloat(comp.opacity || "1") === 0;

  const prev = {
    display: tooltip.style.display,
    visibility: tooltip.style.visibility,
    opacity: tooltip.style.opacity,
    pointerEvents: tooltip.style.pointerEvents
  };

  if (wasHidden) {
    // tooltip.style.visibility = "hidden";
    tooltip.style.display = "block";
    tooltip.style.opacity = "0";
    tooltip.style.pointerEvents = "none";
  }

  const ttRect = tooltip.getBoundingClientRect();
  const hsRect = hotspot.getBoundingClientRect();

  if (wasHidden) {
    tooltip.style.display = prev.display || "";
    tooltip.style.visibility = prev.visibility || "";
    tooltip.style.opacity = prev.opacity || "";
    tooltip.style.pointerEvents = prev.pointerEvents || "";
  }

  const hsCenterX = hsRect.left + hsRect.width / 2 - containerRect.left;
  const hsCenterY = hsRect.top + hsRect.height / 2 - containerRect.top;
  const ttW = Math.round(ttRect.width);
  const ttH = Math.round(ttRect.height);

  const posFor = dir => {
    if (dir === "top") return { left: hsCenterX - ttW / 2, top: hsRect.top - containerRect.top - ttH - gap };
    if (dir === "bottom") return { left: hsCenterX - ttW / 2, top: hsRect.bottom - containerRect.top + gap };
    if (dir === "left") return { left: hsRect.left - containerRect.left - ttW - gap, top: hsCenterY - ttH / 2 };
    return { left: hsRect.right - containerRect.left + gap, top: hsCenterY - ttH / 2 };
  };

  const fits = dir => {
    const p = posFor(dir);
    return p.left >= minOffset && (p.left + ttW) <= (containerRect.width - minOffset) && p.top >= minOffset && (p.top + ttH) <= (containerRect.height - minOffset);
  };

  const visibleArea = dir => {
    const p = posFor(dir);
    const left = Math.max(0, p.left);
    const top = Math.max(0, p.top);
    const right = Math.max(0, Math.min(containerRect.width, p.left + ttW));
    const bottom = Math.max(0, Math.min(containerRect.height, p.top + ttH));
    const w = Math.max(0, right - left);
    const h = Math.max(0, bottom - top);
    return w * h;
  };

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    const ratioY = hsCenterY / containerRect.height;
    const nearTop = ratioY < 0.45;
    const nearBottom = ratioY > 0.55;

    let dir = "bottom";
    if (nearBottom) dir = "top";

    if (dir === "bottom" && !fits("bottom") && fits("top")) dir = "top";
    if (dir === "top" && !fits("top") && fits("bottom")) dir = "bottom";

    let left = hsCenterX - ttW / 2;

    const imageContentEl = dotsWithImageEl.querySelector(".lh-image-content") || dotsWithImageEl;
    const contentRect = imageContentEl.getBoundingClientRect();
    const contentLeftRel = contentRect.left - containerRect.left + minOffset;
    const contentRightRel = contentRect.right - containerRect.left - minOffset;

    if (left < contentLeftRel) left = contentLeftRel;
    if (left + ttW > contentRightRel) left = contentRightRel - ttW;
    left = Math.max(minOffset, Math.min(left, containerRect.width - ttW - minOffset));

    const parentRect = tooltip.offsetParent ? tooltip.offsetParent.getBoundingClientRect() : containerRect;
    const parentOffsetLeft = parentRect.left - containerRect.left;

    tooltip.style.position = "absolute";
    tooltip.style.left = `${Math.round(left - parentOffsetLeft)}px`;

    if (dir === "bottom") {
      tooltip.style.top = "calc(100% + 24px)";
      tooltip.style.transform = "none";
    } else {
      tooltip.style.top = "calc(-100% - 124px)";
      tooltip.style.transform = "none";
    }

    tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    tooltip.classList.add(`lh-preview-${dir}`);

    return;
  }

  tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
  const ratioX = hsCenterX / containerRect.width;
  const ratioY = hsCenterY / containerRect.height;
  const nearLeft = ratioX < 0.25;
  const nearRight = ratioX > 0.75;
  const nearTop = ratioY < 0.25;
  const nearBottom = ratioY > 0.75;

  if (nearRight && nearBottom) { tooltip.classList.add("lh-preview-bottom-right"); return; }
  if (nearLeft && nearBottom)  { tooltip.classList.add("lh-preview-bottom-left"); return; }
  if (nearRight && nearTop)    { tooltip.classList.add("lh-preview-top-right"); return; }
  if (nearLeft && nearTop)     { tooltip.classList.add("lh-preview-top-left"); return; }
  if (nearRight)               { tooltip.classList.add("lh-preview-left"); return; }
  if (nearLeft)                { tooltip.classList.add("lh-preview-right"); return; }
  if (nearBottom)              { tooltip.classList.add("lh-preview-top"); return; }
  if (nearTop)                 { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("bottom"))          { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("top"))             { tooltip.classList.add("lh-preview-top"); return; }
  if (fits("right"))           { tooltip.classList.add("lh-preview-right"); return; }
  if (fits("left"))            { tooltip.classList.add("lh-preview-left"); return; }

  const areas = { top: visibleArea("top"), bottom: visibleArea("bottom"), left: visibleArea("left"), right: visibleArea("right") };
  const best = Object.keys(areas).sort((a,b)=>areas[b]-areas[a])[0];
  tooltip.classList.add(`lh-preview-${best}`);
}



 
function previewCheck() {
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    const observer = new MutationObserver(() => adjustPreviewDirection(tooltip, hotspot));
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: [
        "data-horizontal-de", "data-vertical-de",
        "data-horizontal-ta", "data-vertical-ta",
        "data-horizontal-mo", "data-vertical-mo",
      ],
    });
    adjustPreviewDirection(tooltip, hotspot);
  });
}
hotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", () => {
    currentIndex = index;
    hotspots.forEach((hs, i) => hs.classList.toggle("active", i === index));
    lastActiveIndex = Number(index);
    wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
  });
});
function handlewrapperClick(e) {
  const clickedHotspot = e.target.closest(".lh-hotspot");
  const clickedPreview = e.target.closest(".lh-product-preview");
  const isSection = e.target.classList.contains("lh-section");
  if (!clickedHotspot && !clickedPreview) {
    if (mode === "dev" && isSection) return;
    hotspots.forEach((hotspot) => hotspot.classList.remove("active"));
    if (typeof closePopup === "function") closePopup();
    else if (typeof closeAllPreviews === "function") closeAllPreviews();
  }
}

function updateOverflowBody() {
  const isMobile = window.innerWidth < 640;
  document.body.style.overflow = (isMobile && isPopupOpen) ? "hidden" : "auto";
}
requestAnimationFrame(previewCheck);
window.addEventListener("resize", () => {
  updateOverflowBody();
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    adjustPreviewDirection(tooltip, hotspot);
  });
});

let isPopupOpen = false;
let activeHotspot = null;

function closeAllPreviews() {
  hotspots.forEach(h => h.classList.remove("active"));
  isPopupOpen = false;
  activeHotspot = null;
  document.body.style.overflow = "auto";
}

hotspots.forEach(hotspot => {
  hotspot.addEventListener("click", (e) => {
    const wasActive = hotspot.classList.contains("active");
    closeAllPreviews();
    if (wasActive) return;

    hotspot.classList.add("active");
    activeHotspot = hotspot;
    isPopupOpen = true;

    // if (window.innerWidth < 768) {
    //   document.body.style.overflow = "hidden";
    // }

    const tooltip = hotspot.querySelector(".lh-product-preview");
    if (tooltip) {
      requestAnimationFrame(() => {
        adjustPreviewDirection(tooltip, hotspot);
      });
    }
  });
});

wrapper.addEventListener("click", (e) => {
  const insideHotspot = e.target.closest(".lh-hotspot");
  const insidePreview = e.target.closest(".lh-product-preview");
  if (!insideHotspot && !insidePreview) {
    closeAllPreviews();
  }
});


const MOBILE_BREAKPOINT = 767;
let currentMode = window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop";

function enableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) return; 
    const tooltip = h.querySelector(".lh-product-preview");
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "class") {
          const isActive = h.classList.contains("active");
          if (isActive) {
            if (tooltip) adjustPreviewDirection(tooltip, h);
            // document.body.style.overflow = "hidden";
            isPopupOpen = true;
            activeHotspot = h;
          } else {
            if (tooltip) {
              tooltip.style.left = "";
              tooltip.style.top = "";
              tooltip.style.position = "";
              tooltip.style.transform = "";
              tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
            }
            document.body.style.overflow = "auto";
            isPopupOpen = false;
            if (activeHotspot === h) activeHotspot = null;
          }
        }
      });
    });
    obs.observe(h, { attributes: true, attributeFilter: ["class"] });
    h._lhMobileObserver = obs;
  });

  if (!document._lhMobileOutside) {
    document._lhMobileOutside = function(e) {
      if (!e.target.closest(".lh-hotspot") && !e.target.closest(".lh-product-preview")) {
        closeAllPreviews();
      }
    };
    document.addEventListener("click", document._lhMobileOutside);
  }
}

function disableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) {
      try { h._lhMobileObserver.disconnect(); } catch (e) {}
      delete h._lhMobileObserver;
    }
    const tooltip = h.querySelector(".lh-product-preview");
    if (tooltip) {
      tooltip.style.left = "";
      tooltip.style.top = "";
      tooltip.style.position = "";
      tooltip.style.transform = "";
      tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    }
  });

  if (document._lhMobileOutside) {
    document.removeEventListener("click", document._lhMobileOutside);
    delete document._lhMobileOutside;
  }
  document.body.style.overflow = "auto";
  isPopupOpen = false;
  activeHotspot = null;
}

if (currentMode === "mobile") {
  enableMobileObservers();
} else {
  previewCheck();
}



/* LayoutHub assets/lh-swatch.js */
const settingsEl = wrapper.querySelector('#money-settings');

let rawFormat = settingsEl?.dataset.format || '{{amount}}';
rawFormat = rawFormat.replace(/&quot;/g, '"').replace(/^"|"$/g, '');
const moneyFormat = rawFormat;
const currency = settingsEl?.dataset.currency || 'USD';

function formatMoney(cents, format = moneyFormat) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = isNaN(cents) ? 0 : parseInt(cents, 10);

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    number = (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  return format.replace(/{{\s*(\w+)\s*}}/g, (match, token) => {
    switch (token) {
      case 'amount': return formatWithDelimiters(cents / 100, 2);
      case 'amount_no_decimals': return formatWithDelimiters(cents / 100, 0);
      case 'amount_with_comma_separator': return formatWithDelimiters(cents / 100, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatWithDelimiters(cents / 100, 0, '.', ',');
      case 'currency': return currency;
      default: return formatWithDelimiters(cents / 100, 2);
    }
  });
}

function updateSwatchThumbnail(productBox, dataSrc) {
  const thumbnail = productBox.querySelector('.lh-product-thumbnail .img-with-variant');
  if (dataSrc && thumbnail) {
    thumbnail.src = dataSrc;
    thumbnail.srcset = dataSrc;
  }
}

wrapper.querySelectorAll('.lh-product-box[data-product-id]').forEach(productBox => {
  const select = productBox.querySelector('.lh-single-option-selector');
  const idInput = productBox.querySelector('[name="id"]');
  const priceEl = productBox.querySelector('.lh-special-price .lh-price');
  const compareEl = productBox.querySelector('.lh-old-price .lh-price');
  const button = productBox.querySelector('.lh-add-to-cart');

  const scriptEl = productBox.querySelector('.lh-product-json');
  if (!scriptEl) return;
  const data = JSON.parse(scriptEl.textContent);
  const variants = data.variants || [];
  const swatches = productBox.querySelectorAll('.lh-swatch');


  // ======= Set Default Variant =======
  swatches.forEach(swatch => {
    const radios = swatch.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const swatchEl = radio.closest('.lh-swatch-element');
      if (!radio.disabled) {
        radio.checked = true;
        if (!swatchEl?.classList.contains('lh-sold-out')) {
          if (swatchEl?.classList.contains('lh-color')) {
            updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
          }
        }
        break;
      }
    }
  });

  updateSelectedVariant();

  productBox.addEventListener('change', e => {
    if (e.target.matches('.lh-swatch-element input[type="radio"]')) {
      updateSelectedVariant();
    }
  });

  productBox.addEventListener('click', e => {
    const swatchEl = e.target.closest('.lh-swatch-element.lh-color');
    if (swatchEl) {
      updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
    }
  });
  function updateSelectedVariant() {
    const selectedOptions = Array.from(swatches).map(swatch =>
      swatch.querySelector('input[type="radio"]:checked')?.value.trim() || ''
    );

    const matchedVariant = variants.find(v =>
      Array.isArray(v.options) &&
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!matchedVariant) return;
    updateVariantPrice(productBox, matchedVariant);

    
    updateVariantPrice(productBox, matchedVariant);

    const contactText = document.querySelector('.data-tex-locales')?.dataset.textContact || 'Contact';

    // Update Inputs
    if (idInput) idInput.value = matchedVariant.id;
    if (select) {
      select.value = matchedVariant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update Price
    if (priceEl) {
      priceEl.innerHTML = matchedVariant.price === 0
        ? contactText
        : formatMoney(matchedVariant.price, moneyFormat);
    }

    if (compareEl) {
      compareEl.innerHTML =
        matchedVariant.compare_at_price > matchedVariant.price && matchedVariant.price > 0
          ? formatMoney(matchedVariant.compare_at_price, moneyFormat)
          : '';
    }

    // Update Button

    if (button && idInput) {
      let productLabels = {};
      const labelScript = wrapper.querySelector('#product-button-labels');

      try {
        productLabels = JSON.parse(labelScript?.textContent || '{}');
      } catch (e) {
        console.warn('Failed to parse product labels:', e);
      }

      const isContact = matchedVariant.price === 0;
      const isAvailable = matchedVariant.available;
      const shouldDisable = isContact || !isAvailable;
      button.disabled = shouldDisable;
      button.style.pointerEvents = shouldDisable ? 'none' : 'auto';
      const span = button.querySelector('span');
      if (span) {
        if (!isAvailable) {
          span.textContent = productLabels.inventoryOutOfStock || 'Out of stock';
        } else if (isContact) {
          span.textContent = productLabels.chooseOptions || 'Choose options';
        } else {
          span.textContent = productLabels.addToCart || 'Add to cart';
        }
      }

      button.addEventListener('click', (e) => {
        const variantId = parseInt(idInput.value, 10);
        const variant = variants.find(v => v.id === variantId);
        if (!variant || variant.price === 0 || !variant.available) {
          e.preventDefault();
        }
      });
    }



    // Disable unavailable swatches
    swatches.forEach((swatch, index) => {
      const radios = swatch.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const value = radio.value.trim();
        const testOptions = [...selectedOptions];
        testOptions[index] = value;

        const available = variants.some(v =>
          v.available && v.options.every((opt, i) => opt === testOptions[i])
        );

        const swatchEl = radio.closest('.lh-swatch-element');
        swatchEl?.classList.toggle('lh-sold-out', !available);
      });
    });
  }

});


const bundleSubmitBtn = wrapper.querySelector("[data-product-bundle-submit]");
if (mode !== "dev") {
  if (bundleSubmitBtn) {
    bundleSubmitBtn.addEventListener("click", () => {
      if (bundleState.items.length === 0) return;

      const itemsToAdd = bundleState.items.map((i) => ({
        id: i.variantId,
        quantity: i.quantity,
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      })
        .then((res) => res.json())
        .then(() => {
          bundleState.items = [];
          renderBundle();
          updateBundleTotal();

          if (typeof window.showCartDrawer === "function") {
            window.showCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((err) => console.error(err));
    });
  }
} 

function updateVariantPrice(wrapper, variant) {
  const priceBox = wrapper.querySelector('.lh-price-box');
  if (!priceBox) return;

  const currentPriceEl = priceBox.querySelector('.lh-current-price');
  const oldPriceEl = priceBox.querySelector('.lh-old-price');

  const formattedPrice = formatMoney(variant.price, moneyFormat);
  const formattedCompare = variant.compare_at_price
    ? formatMoney(variant.compare_at_price, moneyFormat)
    : '';

  if (currentPriceEl) currentPriceEl.textContent = formattedPrice;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (oldPriceEl) {
      oldPriceEl.textContent = formattedCompare;
      oldPriceEl.style.display = 'inline';
    } else {
      const span = document.createElement('span');
      span.className = 'lh-old-price line-through !text-[var(--lh-other-sale-price-color)] lh-p2';
      span.textContent = formattedCompare;
      priceBox.appendChild(span);
    }
  } else if (oldPriceEl) {
    oldPriceEl.style.display = 'none';
  }
}



})(document.querySelector('section.lh-2ehs71'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
window.LayoutHubSlider(wrapper);

wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const url = this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  });
});


const syncGridAndHotspot = () => {
  const targetSelector = '.lh-grid-item';
  const hotspotSelector = '.lh-dots-with-image .lh-hotspot';
  const dotSelector = '.lh-slider-pagination-wrapper button';

  const activateHotspotByIndex = (index) => {
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) matchedHotspot.classList.add('active');
    markActiveItem();
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('active'));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add('active');
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
    }
    markActiveItem();
  };

  const markActiveItem = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('activeItem'));
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));

    const totalItems = wrapper.querySelectorAll(targetSelector).length;
    const activeItems = Array.from(wrapper.querySelectorAll(`${targetSelector}.active`));

    if (totalItems <= 2) {
      wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.add('active'));
      if (activeItems.length) {
        activeItems.forEach(item => item.classList.add('activeItem'));
      }
      return;
    }

    if (activeItems.length === 1) {
      activeItems[0].classList.add('activeItem');

      const index = activeItems[0].dataset.index;
      const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
      if (matchedHotspot) matchedHotspot.classList.add('active');
    } else if (activeItems.length > 1) {
      const indexes = activeItems.map(el => Number(el.dataset.index)).sort((a, b) => a - b);
      const firstIndex = indexes[0];
      const lastIndex = indexes[indexes.length - 1];

      let chosenIndex;
      if (firstIndex === 0 && lastIndex === totalItems - 1) {
        chosenIndex = lastIndex;
      } else {
        chosenIndex = firstIndex;
      }

      const chosenItem = activeItems.find(el => Number(el.dataset.index) === chosenIndex);
      if (chosenItem) {
        chosenItem.classList.add('activeItem');

        const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${chosenIndex}"]`);
        if (matchedHotspot) matchedHotspot.classList.add('active');
      }
    }
  };

  const setupGridClick = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => {
      item.addEventListener('click', () => {
        const index = item.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupHotspotClick = () => {
    wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = hotspot.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupDotClick = () => {
    wrapper.querySelectorAll(dotSelector).forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.index;
        if (index !== undefined) {
          activateItemByIndex(index);
          activateHotspotByIndex(index);
        }
      });
    });
  };

  const syncInitialState = () => {
    const activeItem = wrapper.querySelector(`${targetSelector}.active`);
    if (activeItem) {
      activateHotspotByIndex(activeItem.dataset.index);
    }
    markActiveItem();
  };

  if (wrapper.embla) {
    wrapper.embla.on('select', () => {
      markActiveItem();
    });
  }

  setupGridClick();
  setupHotspotClick();
  setupDotClick();
  syncInitialState();
};

syncGridAndHotspot();

if (mode != 'dev') {
  wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
  wrapper.querySelectorAll(".lh-rating-preview").forEach(function (el) {
    el.remove();
  });
} else {
  wrapper.querySelectorAll(".lh-rating-live").forEach(function (el) {
    el.remove();
  });
}


wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
  const productJsonEl = form.querySelector(".lh-product-json");
  const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
  if (!productJsonEl || !realSelect) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent || "{}");
  } catch (err) {
    console.error("Parse product JSON failed:", err);
    return;
  }
  if (!Array.isArray(productData.variants) || productData.variants.length === 0) return;

  const selects = form.querySelectorAll(".lh-custom-select");
  const updateVariant = () => {
    const selectedValues = Array.from(selects).map((sel) => {
      const txt = sel.querySelector(".selected-text");
      return txt ? txt.textContent.trim().toLowerCase() : "";
    });

    let matchedVariant = productData.variants.find((v) => {
      const opts = v.options.map((o) => (o ? o.trim().toLowerCase() : ""));
      return opts.every((optVal, i) => optVal === (selectedValues[i] || ""));
    });

    if (!matchedVariant) matchedVariant = productData.variants[0];
 
    realSelect.value = matchedVariant.id;
    realSelect.dispatchEvent(new Event("change", { bubbles: true }));
    
    selects.forEach((sel, i) => {
      const txt = sel.querySelector(".selected-text");
      const opts = sel.querySelectorAll(".lh-option");
      const newVal = matchedVariant.options[i] || "";
      if (txt) txt.textContent = newVal;

      opts.forEach((optEl) => {
        const inputEl = optEl.querySelector("input");
        const optValue = optEl.dataset.value?.trim().toLowerCase() || "";
        if (inputEl) inputEl.checked = optValue === newVal.trim().toLowerCase();
      });
    });
  };

wrapper.querySelectorAll(".lh-swatch-element input[type='radio']").forEach((inputEl) => {
  inputEl.addEventListener("change", (e) => {
    const form = e.target.closest("form.lh-product-box");
    if (!form) return;

    const selects = form.querySelectorAll(".lh-custom-select");
    const optionIndex = e.target.name.replace("option-", "");
    const value = e.target.value;

    const select = Array.from(selects).find(s => s.dataset.optionIndex === optionIndex);
    if (!select) return;

    const txt = select.querySelector(".selected-text");
    const preview = select.querySelector(".w-4.h-4.inline-block");
    const display = select.querySelector(".lh-select-display");

    if (txt) txt.textContent = value;
    if (display) display.setAttribute("aria-label", value);

    const colorKey = value.trim().toLowerCase().replace(/\s+/g, "-");
    if (preview) {
      const useImage = preview.style.backgroundImage.includes("url");
      if (useImage) {
        preview.style.backgroundImage = `var(--lh-swi-${colorKey})`;
      } else {
        preview.style.backgroundColor = `var(--lh-swc-${colorKey})`;
      }
    }

    const swatchWrapper = e.target.closest(".lh-custom-select");
    if (swatchWrapper) {
      const allSwatches = swatchWrapper.querySelectorAll(".lh-swatch-element");
      allSwatches.forEach(sw => sw.classList.remove("active"));
      const parentSw = e.target.closest(".lh-swatch-element");
      if (parentSw) parentSw.classList.add("active");
    }

    updateVariant();

    select.classList.remove("active");
  });
});

  selects.forEach((select) => {
    const display = select.querySelector(".lh-select-display");
    const optionsBox = select.querySelector(".lh-select-options");
    if (!display || !optionsBox) return;

    display.addEventListener("click", (e) => {
    e.stopPropagation();

    const isActive = select.classList.contains("active");

    // Toggle
    if (isActive) {
      select.classList.remove("active");
      optionsBox.classList.remove("open-up");
    } else {
      // Đóng tất cả select khác trước
      wrapper.querySelectorAll(".lh-custom-select.active").forEach((other) => {
        other.classList.remove("active");
        other.querySelector(".lh-select-options")?.classList.remove("open-up");
      });

      select.classList.add("active");

      const rect = optionsBox.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      if (spaceBelow < 100 && spaceAbove > spaceBelow) {
        optionsBox.classList.add("open-up");
      } else {
        optionsBox.classList.remove("open-up");
      }
    }
  });

  optionsBox.querySelectorAll(".lh-option").forEach((opt) => {
    opt.addEventListener("click", (e) => {
      e.stopPropagation();

      const input = opt.querySelector("input");
      if (input) input.checked = true;

      const value = opt.dataset.value || "";
      const txt = select.querySelector(".selected-text");
      const display = select.querySelector(".lh-select-display");
      if (txt) txt.textContent = value;
      if (display) display.setAttribute("aria-label", value);

      select.classList.remove("active");
      optionsBox.classList.remove("open-up");

      updateVariant();
    });
  });
});

wrapper.addEventListener("click", (e) => {
  wrapper.querySelectorAll(".lh-custom-select.active").forEach((sel) => {
    sel.classList.remove("active");
  });
});

  updateVariant();
});

function updateActiveSwatchBackground(select) {
  const display = select.querySelector(".lh-select-display");
  const displayLabel = display?.getAttribute("aria-label");
  const swatches = select.querySelectorAll(".lh-swatch-element");

  swatches.forEach(sw => {
    const input = sw.querySelector("input[type='radio']");
    const label = input?.getAttribute("aria-label");
    if (label && displayLabel && label.trim().toLowerCase() === displayLabel.trim().toLowerCase()) {
      sw.style.background = "#dfdfdfab";
      sw.style.color = "#181818 !important";
      sw.classList.add("active");
    } else {
      sw.style.background = "";
      sw.classList.remove("active");
    }
  });
}

const selects = wrapper.querySelectorAll(".lh-custom-select");

  selects.forEach(select => {
    const firstSwatch = select.querySelector('.lh-swatch-element[data-index="0"]');
    const firstInput = firstSwatch?.querySelector("input[type='radio']");
    const display = select.querySelector(".lh-select-display");

    if (firstSwatch && firstInput && display) {
      const firstLabel = firstInput.getAttribute("aria-label");
      display.setAttribute("aria-label", firstLabel);

      updateActiveSwatchBackground(select);
    }

    const swatches = select.querySelectorAll(".lh-swatch-element");
    swatches.forEach(sw => {
      const input = sw.querySelector("input[type='radio']");
      sw.addEventListener("click", () => {
        const label = input?.getAttribute("aria-label");
        if (label && display) {
          display.setAttribute("aria-label", label);
          updateActiveSwatchBackground(select);
        }
      });
    });
  });



if (mode != 'dev') {
  const bundleBtn = wrapper.querySelector("[data-product-bundle-submit]");
  const bundleMessage = wrapper.querySelector(".lh-error");

  const checkBundleAvailability = () => {
    if (!bundleBtn) return;
    let unavailable = false;

    wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (!variant || !variant.available || Number(variant.price) <= 0) {
        unavailable = true;
      }
    });

    if (unavailable) {
      bundleBtn.disabled = true;
      bundleBtn.classList.add("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "One or more products are sold out or have a price of 0.";
    } else {
      bundleBtn.disabled = false;
      bundleBtn.classList.remove("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "";
    }
  };

  wrapper.querySelectorAll("form.lh-product-box .lh-single-option-selector").forEach((select) => {
    select.addEventListener("change", checkBundleAvailability);
  });

  checkBundleAvailability();

  bundleBtn?.addEventListener("click", async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const spinner = btn.querySelector(".lh-loading__spinner");
    const textSpan = btn.querySelector(".btn-text");

    if (textSpan) textSpan.style.opacity = "0.4";
    spinner?.classList.remove("lh-hidden");
    if (bundleMessage) bundleMessage.textContent = "";

    const forms = wrapper.querySelectorAll("form.lh-product-box");
    const itemsToAdd = [];

    forms.forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const quantityInput = form.querySelector("input[name='quantity']") || { value: 1 };
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (variant && variant.available && Number(variant.price) > 0) {
        itemsToAdd.push({
          id: Number(realSelect.value),
          quantity: Number(quantityInput.value || 1),
        });
      }
    });

    if (itemsToAdd.length === 0) {
      spinner?.classList.add("lh-hidden");
      if (textSpan) textSpan.style.opacity = "1";
      return;
    }

    try {
      for (const item of itemsToAdd) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
      }
      window.location.href = "/cart"; 
    } catch (err) {
      if (bundleMessage) bundleMessage.textContent = "Failed to add bundle to cart.";
    }
  });
}

function reindexProductsAndLookbooks(wrapper) {
  const productItems = Array.from(wrapper.querySelectorAll('.lh-product-index')).filter(Boolean);
  const lookbookItems = Array.from(wrapper.querySelectorAll('.lh-lookbook-index')).filter(Boolean);

  productItems.forEach((item, index) => {
    item.dataset.index = index; 
  });

  lookbookItems.forEach((item, index) => {
    item.dataset.index = index;
  });

  console.log(`🔁 Reindexed: ${productItems.length} products, ${lookbookItems.length} lookbooks`);
}

reindexProductsAndLookbooks(wrapper);

const observerTarget =
  wrapper.querySelector('.lh-slider-container') ||
  wrapper.querySelector('.lh-grid') ||
  wrapper;

const observer = new MutationObserver((mutations) => {
  let shouldReindex = false;

  for (const mutation of mutations) {
    if (
      mutation.type === 'childList' &&
      ([...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) =>
          node.classList?.contains?.('lh-product-index') ||
          node.classList?.contains?.('lh-lookbook-index') ||
          node.querySelector?.('.lh-product-index') ||
          node.querySelector?.('.lh-lookbook-index')
      ))
    ) {
      shouldReindex = true;
      break;
    }
  }

  if (shouldReindex) {
    requestAnimationFrame(() => reindexProductsAndLookbooks(wrapper));
  }
});

observer.observe(observerTarget, {
  childList: true,
  subtree: true,
});






/* LayoutHub assets/lookbook.js */
const slideItems = wrapper.querySelectorAll(".lh-slide-item");
const hotspots = wrapper.querySelectorAll(".lh-hotspot");
const dotsWithImageEl = wrapper.querySelector(".lh-dots-with-image");
let currentIndex = 0;
let lastActiveIndex = Number(wrapper.dataset.lhLastActiveIndex) || 0;

function restoreLastActive() {
  requestAnimationFrame(() => {
    const targetSelector = ".lh-grid-item";
    const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${lastActiveIndex}"]`);
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${lastActiveIndex}"]`);
    if (matchedItem) matchedItem.classList.add("active");
    if (matchedHotspot) matchedHotspot.classList.add("active");
    if (wrapper.embla && !isNaN(lastActiveIndex)) wrapper.embla.scrollTo(Number(lastActiveIndex));
  });
}

const syncGridAndHotspotlook = () => {
  const targetSelector = ".lh-grid-item";
  const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
  const dotSelector = ".lh-slider-pagination-wrapper button";

  const activateHotspotByIndex = (index) => {

    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove("active"));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) {
      matchedHotspot.classList.add("active");
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove("active"));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add("active");
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  wrapper.querySelectorAll(targetSelector).forEach(item => {
    item.addEventListener("click", () => {
      const index = item.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  });

  wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
    hotspot.addEventListener("click", () => {
      const index = hotspot.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);

    });
  });

  wrapper.querySelectorAll(dotSelector).forEach(dot => {
    dot.addEventListener("click", () => {
      const index = dot.dataset.index;
      if (index !== undefined) {
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      }
    });
  });

  const activeItem = wrapper.querySelector(`${targetSelector}.active`);
  if (activeItem) activateHotspotByIndex(activeItem.dataset.index);

  if (wrapper.embla) {
    wrapper.embla.on("select", () => {
      const index = wrapper.embla.selectedScrollSnap();
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  }

  restoreLastActive();
  requestAnimationFrame(() => {
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  });
};
syncGridAndHotspotlook();

slideItems.forEach((slideItem, index) => {
  const hotspot = hotspots[index];
  if (!hotspot) return;
  const productPreview = hotspot.querySelector(".lh-product-preview");
  if (!productPreview) return;
  const updateClone = () => {
    const slideItemClone = slideItem.cloneNode(true);
    productPreview.innerHTML = "";
    productPreview.append(slideItemClone);
    if (mode === "dev") {
      slideItemClone.querySelectorAll("a").forEach(a => {
        a.removeAttribute("href");
        a.addEventListener("click", e => e.preventDefault());
        a.style.cursor = "default";
      });
    }

    restoreLastActive();
    requestAnimationFrame(() => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  };
  updateClone();
  const observer = new MutationObserver(updateClone);
  observer.observe(slideItem, {
    attributes: true,
    attributeFilter: ["class", "style"],
    childList: true,
    subtree: true
  });
});

function adjustPreviewDirection(tooltip, hotspot) {
  if (!tooltip || !hotspot || !dotsWithImageEl) return;

  const minOffset = Number(hotspot.getAttribute("data-tooltip-min-offset")) || 10;
  const gap = 8;
  const containerRect = dotsWithImageEl.getBoundingClientRect();

  const comp = window.getComputedStyle(tooltip);
  const wasHidden =
    comp.display === "none" ||
    comp.visibility === "hidden" ||
    parseFloat(comp.opacity || "1") === 0;

  const prev = {
    display: tooltip.style.display,
    visibility: tooltip.style.visibility,
    opacity: tooltip.style.opacity,
    pointerEvents: tooltip.style.pointerEvents
  };

  if (wasHidden) {
    // tooltip.style.visibility = "hidden";
    tooltip.style.display = "block";
    tooltip.style.opacity = "0";
    tooltip.style.pointerEvents = "none";
  }

  const ttRect = tooltip.getBoundingClientRect();
  const hsRect = hotspot.getBoundingClientRect();

  if (wasHidden) {
    tooltip.style.display = prev.display || "";
    tooltip.style.visibility = prev.visibility || "";
    tooltip.style.opacity = prev.opacity || "";
    tooltip.style.pointerEvents = prev.pointerEvents || "";
  }

  const hsCenterX = hsRect.left + hsRect.width / 2 - containerRect.left;
  const hsCenterY = hsRect.top + hsRect.height / 2 - containerRect.top;
  const ttW = Math.round(ttRect.width);
  const ttH = Math.round(ttRect.height);

  const posFor = dir => {
    if (dir === "top") return { left: hsCenterX - ttW / 2, top: hsRect.top - containerRect.top - ttH - gap };
    if (dir === "bottom") return { left: hsCenterX - ttW / 2, top: hsRect.bottom - containerRect.top + gap };
    if (dir === "left") return { left: hsRect.left - containerRect.left - ttW - gap, top: hsCenterY - ttH / 2 };
    return { left: hsRect.right - containerRect.left + gap, top: hsCenterY - ttH / 2 };
  };

  const fits = dir => {
    const p = posFor(dir);
    return p.left >= minOffset && (p.left + ttW) <= (containerRect.width - minOffset) && p.top >= minOffset && (p.top + ttH) <= (containerRect.height - minOffset);
  };

  const visibleArea = dir => {
    const p = posFor(dir);
    const left = Math.max(0, p.left);
    const top = Math.max(0, p.top);
    const right = Math.max(0, Math.min(containerRect.width, p.left + ttW));
    const bottom = Math.max(0, Math.min(containerRect.height, p.top + ttH));
    const w = Math.max(0, right - left);
    const h = Math.max(0, bottom - top);
    return w * h;
  };

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    const ratioY = hsCenterY / containerRect.height;
    const nearTop = ratioY < 0.45;
    const nearBottom = ratioY > 0.55;

    let dir = "bottom";
    if (nearBottom) dir = "top";

    if (dir === "bottom" && !fits("bottom") && fits("top")) dir = "top";
    if (dir === "top" && !fits("top") && fits("bottom")) dir = "bottom";

    let left = hsCenterX - ttW / 2;

    const imageContentEl = dotsWithImageEl.querySelector(".lh-image-content") || dotsWithImageEl;
    const contentRect = imageContentEl.getBoundingClientRect();
    const contentLeftRel = contentRect.left - containerRect.left + minOffset;
    const contentRightRel = contentRect.right - containerRect.left - minOffset;

    if (left < contentLeftRel) left = contentLeftRel;
    if (left + ttW > contentRightRel) left = contentRightRel - ttW;
    left = Math.max(minOffset, Math.min(left, containerRect.width - ttW - minOffset));

    const parentRect = tooltip.offsetParent ? tooltip.offsetParent.getBoundingClientRect() : containerRect;
    const parentOffsetLeft = parentRect.left - containerRect.left;

    tooltip.style.position = "absolute";
    tooltip.style.left = `${Math.round(left - parentOffsetLeft)}px`;

    if (dir === "bottom") {
      tooltip.style.top = "calc(100% + 24px)";
      tooltip.style.transform = "none";
    } else {
      tooltip.style.top = "calc(-100% - 124px)";
      tooltip.style.transform = "none";
    }

    tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    tooltip.classList.add(`lh-preview-${dir}`);

    return;
  }

  tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
  const ratioX = hsCenterX / containerRect.width;
  const ratioY = hsCenterY / containerRect.height;
  const nearLeft = ratioX < 0.25;
  const nearRight = ratioX > 0.75;
  const nearTop = ratioY < 0.25;
  const nearBottom = ratioY > 0.75;

  if (nearRight && nearBottom) { tooltip.classList.add("lh-preview-bottom-right"); return; }
  if (nearLeft && nearBottom)  { tooltip.classList.add("lh-preview-bottom-left"); return; }
  if (nearRight && nearTop)    { tooltip.classList.add("lh-preview-top-right"); return; }
  if (nearLeft && nearTop)     { tooltip.classList.add("lh-preview-top-left"); return; }
  if (nearRight)               { tooltip.classList.add("lh-preview-left"); return; }
  if (nearLeft)                { tooltip.classList.add("lh-preview-right"); return; }
  if (nearBottom)              { tooltip.classList.add("lh-preview-top"); return; }
  if (nearTop)                 { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("bottom"))          { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("top"))             { tooltip.classList.add("lh-preview-top"); return; }
  if (fits("right"))           { tooltip.classList.add("lh-preview-right"); return; }
  if (fits("left"))            { tooltip.classList.add("lh-preview-left"); return; }

  const areas = { top: visibleArea("top"), bottom: visibleArea("bottom"), left: visibleArea("left"), right: visibleArea("right") };
  const best = Object.keys(areas).sort((a,b)=>areas[b]-areas[a])[0];
  tooltip.classList.add(`lh-preview-${best}`);
}



 
function previewCheck() {
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    const observer = new MutationObserver(() => adjustPreviewDirection(tooltip, hotspot));
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: [
        "data-horizontal-de", "data-vertical-de",
        "data-horizontal-ta", "data-vertical-ta",
        "data-horizontal-mo", "data-vertical-mo",
      ],
    });
    adjustPreviewDirection(tooltip, hotspot);
  });
}
hotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", () => {
    currentIndex = index;
    hotspots.forEach((hs, i) => hs.classList.toggle("active", i === index));
    lastActiveIndex = Number(index);
    wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
  });
});
function handlewrapperClick(e) {
  const clickedHotspot = e.target.closest(".lh-hotspot");
  const clickedPreview = e.target.closest(".lh-product-preview");
  const isSection = e.target.classList.contains("lh-section");
  if (!clickedHotspot && !clickedPreview) {
    if (mode === "dev" && isSection) return;
    hotspots.forEach((hotspot) => hotspot.classList.remove("active"));
    if (typeof closePopup === "function") closePopup();
    else if (typeof closeAllPreviews === "function") closeAllPreviews();
  }
}

function updateOverflowBody() {
  const isMobile = window.innerWidth < 640;
  document.body.style.overflow = (isMobile && isPopupOpen) ? "hidden" : "auto";
}
requestAnimationFrame(previewCheck);
window.addEventListener("resize", () => {
  updateOverflowBody();
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    adjustPreviewDirection(tooltip, hotspot);
  });
});

let isPopupOpen = false;
let activeHotspot = null;

function closeAllPreviews() {
  hotspots.forEach(h => h.classList.remove("active"));
  isPopupOpen = false;
  activeHotspot = null;
  document.body.style.overflow = "auto";
}

hotspots.forEach(hotspot => {
  hotspot.addEventListener("click", (e) => {
    const wasActive = hotspot.classList.contains("active");
    closeAllPreviews();
    if (wasActive) return;

    hotspot.classList.add("active");
    activeHotspot = hotspot;
    isPopupOpen = true;

    // if (window.innerWidth < 768) {
    //   document.body.style.overflow = "hidden";
    // }

    const tooltip = hotspot.querySelector(".lh-product-preview");
    if (tooltip) {
      requestAnimationFrame(() => {
        adjustPreviewDirection(tooltip, hotspot);
      });
    }
  });
});

wrapper.addEventListener("click", (e) => {
  const insideHotspot = e.target.closest(".lh-hotspot");
  const insidePreview = e.target.closest(".lh-product-preview");
  if (!insideHotspot && !insidePreview) {
    closeAllPreviews();
  }
});


const MOBILE_BREAKPOINT = 767;
let currentMode = window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop";

function enableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) return; 
    const tooltip = h.querySelector(".lh-product-preview");
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "class") {
          const isActive = h.classList.contains("active");
          if (isActive) {
            if (tooltip) adjustPreviewDirection(tooltip, h);
            // document.body.style.overflow = "hidden";
            isPopupOpen = true;
            activeHotspot = h;
          } else {
            if (tooltip) {
              tooltip.style.left = "";
              tooltip.style.top = "";
              tooltip.style.position = "";
              tooltip.style.transform = "";
              tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
            }
            document.body.style.overflow = "auto";
            isPopupOpen = false;
            if (activeHotspot === h) activeHotspot = null;
          }
        }
      });
    });
    obs.observe(h, { attributes: true, attributeFilter: ["class"] });
    h._lhMobileObserver = obs;
  });

  if (!document._lhMobileOutside) {
    document._lhMobileOutside = function(e) {
      if (!e.target.closest(".lh-hotspot") && !e.target.closest(".lh-product-preview")) {
        closeAllPreviews();
      }
    };
    document.addEventListener("click", document._lhMobileOutside);
  }
}

function disableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) {
      try { h._lhMobileObserver.disconnect(); } catch (e) {}
      delete h._lhMobileObserver;
    }
    const tooltip = h.querySelector(".lh-product-preview");
    if (tooltip) {
      tooltip.style.left = "";
      tooltip.style.top = "";
      tooltip.style.position = "";
      tooltip.style.transform = "";
      tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    }
  });

  if (document._lhMobileOutside) {
    document.removeEventListener("click", document._lhMobileOutside);
    delete document._lhMobileOutside;
  }
  document.body.style.overflow = "auto";
  isPopupOpen = false;
  activeHotspot = null;
}

if (currentMode === "mobile") {
  enableMobileObservers();
} else {
  previewCheck();
}



/* LayoutHub assets/lh-swatch.js */
const settingsEl = wrapper.querySelector('#money-settings');

let rawFormat = settingsEl?.dataset.format || '{{amount}}';
rawFormat = rawFormat.replace(/&quot;/g, '"').replace(/^"|"$/g, '');
const moneyFormat = rawFormat;
const currency = settingsEl?.dataset.currency || 'USD';

function formatMoney(cents, format = moneyFormat) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = isNaN(cents) ? 0 : parseInt(cents, 10);

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    number = (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  return format.replace(/{{\s*(\w+)\s*}}/g, (match, token) => {
    switch (token) {
      case 'amount': return formatWithDelimiters(cents / 100, 2);
      case 'amount_no_decimals': return formatWithDelimiters(cents / 100, 0);
      case 'amount_with_comma_separator': return formatWithDelimiters(cents / 100, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatWithDelimiters(cents / 100, 0, '.', ',');
      case 'currency': return currency;
      default: return formatWithDelimiters(cents / 100, 2);
    }
  });
}

function updateSwatchThumbnail(productBox, dataSrc) {
  const thumbnail = productBox.querySelector('.lh-product-thumbnail .img-with-variant');
  if (dataSrc && thumbnail) {
    thumbnail.src = dataSrc;
    thumbnail.srcset = dataSrc;
  }
}

wrapper.querySelectorAll('.lh-product-box[data-product-id]').forEach(productBox => {
  const select = productBox.querySelector('.lh-single-option-selector');
  const idInput = productBox.querySelector('[name="id"]');
  const priceEl = productBox.querySelector('.lh-special-price .lh-price');
  const compareEl = productBox.querySelector('.lh-old-price .lh-price');
  const button = productBox.querySelector('.lh-add-to-cart');

  const scriptEl = productBox.querySelector('.lh-product-json');
  if (!scriptEl) return;
  const data = JSON.parse(scriptEl.textContent);
  const variants = data.variants || [];
  const swatches = productBox.querySelectorAll('.lh-swatch');


  // ======= Set Default Variant =======
  swatches.forEach(swatch => {
    const radios = swatch.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const swatchEl = radio.closest('.lh-swatch-element');
      if (!radio.disabled) {
        radio.checked = true;
        if (!swatchEl?.classList.contains('lh-sold-out')) {
          if (swatchEl?.classList.contains('lh-color')) {
            updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
          }
        }
        break;
      }
    }
  });

  updateSelectedVariant();

  productBox.addEventListener('change', e => {
    if (e.target.matches('.lh-swatch-element input[type="radio"]')) {
      updateSelectedVariant();
    }
  });

  productBox.addEventListener('click', e => {
    const swatchEl = e.target.closest('.lh-swatch-element.lh-color');
    if (swatchEl) {
      updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
    }
  });
  function updateSelectedVariant() {
    const selectedOptions = Array.from(swatches).map(swatch =>
      swatch.querySelector('input[type="radio"]:checked')?.value.trim() || ''
    );

    const matchedVariant = variants.find(v =>
      Array.isArray(v.options) &&
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!matchedVariant) return;
    updateVariantPrice(productBox, matchedVariant);

    
    updateVariantPrice(productBox, matchedVariant);

    const contactText = document.querySelector('.data-tex-locales')?.dataset.textContact || 'Contact';

    // Update Inputs
    if (idInput) idInput.value = matchedVariant.id;
    if (select) {
      select.value = matchedVariant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update Price
    if (priceEl) {
      priceEl.innerHTML = matchedVariant.price === 0
        ? contactText
        : formatMoney(matchedVariant.price, moneyFormat);
    }

    if (compareEl) {
      compareEl.innerHTML =
        matchedVariant.compare_at_price > matchedVariant.price && matchedVariant.price > 0
          ? formatMoney(matchedVariant.compare_at_price, moneyFormat)
          : '';
    }

    // Update Button

    if (button && idInput) {
      let productLabels = {};
      const labelScript = wrapper.querySelector('#product-button-labels');

      try {
        productLabels = JSON.parse(labelScript?.textContent || '{}');
      } catch (e) {
        console.warn('Failed to parse product labels:', e);
      }

      const isContact = matchedVariant.price === 0;
      const isAvailable = matchedVariant.available;
      const shouldDisable = isContact || !isAvailable;
      button.disabled = shouldDisable;
      button.style.pointerEvents = shouldDisable ? 'none' : 'auto';
      const span = button.querySelector('span');
      if (span) {
        if (!isAvailable) {
          span.textContent = productLabels.inventoryOutOfStock || 'Out of stock';
        } else if (isContact) {
          span.textContent = productLabels.chooseOptions || 'Choose options';
        } else {
          span.textContent = productLabels.addToCart || 'Add to cart';
        }
      }

      button.addEventListener('click', (e) => {
        const variantId = parseInt(idInput.value, 10);
        const variant = variants.find(v => v.id === variantId);
        if (!variant || variant.price === 0 || !variant.available) {
          e.preventDefault();
        }
      });
    }



    // Disable unavailable swatches
    swatches.forEach((swatch, index) => {
      const radios = swatch.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const value = radio.value.trim();
        const testOptions = [...selectedOptions];
        testOptions[index] = value;

        const available = variants.some(v =>
          v.available && v.options.every((opt, i) => opt === testOptions[i])
        );

        const swatchEl = radio.closest('.lh-swatch-element');
        swatchEl?.classList.toggle('lh-sold-out', !available);
      });
    });
  }

});


const bundleSubmitBtn = wrapper.querySelector("[data-product-bundle-submit]");
if (mode !== "dev") {
  if (bundleSubmitBtn) {
    bundleSubmitBtn.addEventListener("click", () => {
      if (bundleState.items.length === 0) return;

      const itemsToAdd = bundleState.items.map((i) => ({
        id: i.variantId,
        quantity: i.quantity,
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      })
        .then((res) => res.json())
        .then(() => {
          bundleState.items = [];
          renderBundle();
          updateBundleTotal();

          if (typeof window.showCartDrawer === "function") {
            window.showCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((err) => console.error(err));
    });
  }
} 

function updateVariantPrice(wrapper, variant) {
  const priceBox = wrapper.querySelector('.lh-price-box');
  if (!priceBox) return;

  const currentPriceEl = priceBox.querySelector('.lh-current-price');
  const oldPriceEl = priceBox.querySelector('.lh-old-price');

  const formattedPrice = formatMoney(variant.price, moneyFormat);
  const formattedCompare = variant.compare_at_price
    ? formatMoney(variant.compare_at_price, moneyFormat)
    : '';

  if (currentPriceEl) currentPriceEl.textContent = formattedPrice;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (oldPriceEl) {
      oldPriceEl.textContent = formattedCompare;
      oldPriceEl.style.display = 'inline';
    } else {
      const span = document.createElement('span');
      span.className = 'lh-old-price line-through !text-[var(--lh-other-sale-price-color)] lh-p2';
      span.textContent = formattedCompare;
      priceBox.appendChild(span);
    }
  } else if (oldPriceEl) {
    oldPriceEl.style.display = 'none';
  }
}



})(document.querySelector('section.lh-qd5afc'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
window.LayoutHubSlider(wrapper);

wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const url = this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  });
});


const syncGridAndHotspot = () => {
  const targetSelector = '.lh-grid-item';
  const hotspotSelector = '.lh-dots-with-image .lh-hotspot';
  const dotSelector = '.lh-slider-pagination-wrapper button';

  const activateHotspotByIndex = (index) => {
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) matchedHotspot.classList.add('active');
    markActiveItem();
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('active'));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add('active');
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
    }
    markActiveItem();
  };

  const markActiveItem = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('activeItem'));
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));

    const totalItems = wrapper.querySelectorAll(targetSelector).length;
    const activeItems = Array.from(wrapper.querySelectorAll(`${targetSelector}.active`));

    if (totalItems <= 2) {
      wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.add('active'));
      if (activeItems.length) {
        activeItems.forEach(item => item.classList.add('activeItem'));
      }
      return;
    }

    if (activeItems.length === 1) {
      activeItems[0].classList.add('activeItem');

      const index = activeItems[0].dataset.index;
      const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
      if (matchedHotspot) matchedHotspot.classList.add('active');
    } else if (activeItems.length > 1) {
      const indexes = activeItems.map(el => Number(el.dataset.index)).sort((a, b) => a - b);
      const firstIndex = indexes[0];
      const lastIndex = indexes[indexes.length - 1];

      let chosenIndex;
      if (firstIndex === 0 && lastIndex === totalItems - 1) {
        chosenIndex = lastIndex;
      } else {
        chosenIndex = firstIndex;
      }

      const chosenItem = activeItems.find(el => Number(el.dataset.index) === chosenIndex);
      if (chosenItem) {
        chosenItem.classList.add('activeItem');

        const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${chosenIndex}"]`);
        if (matchedHotspot) matchedHotspot.classList.add('active');
      }
    }
  };

  const setupGridClick = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => {
      item.addEventListener('click', () => {
        const index = item.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupHotspotClick = () => {
    wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = hotspot.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupDotClick = () => {
    wrapper.querySelectorAll(dotSelector).forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.index;
        if (index !== undefined) {
          activateItemByIndex(index);
          activateHotspotByIndex(index);
        }
      });
    });
  };

  const syncInitialState = () => {
    const activeItem = wrapper.querySelector(`${targetSelector}.active`);
    if (activeItem) {
      activateHotspotByIndex(activeItem.dataset.index);
    }
    markActiveItem();
  };

  if (wrapper.embla) {
    wrapper.embla.on('select', () => {
      markActiveItem();
    });
  }

  setupGridClick();
  setupHotspotClick();
  setupDotClick();
  syncInitialState();
};

syncGridAndHotspot();

if (mode != 'dev') {
  wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
  wrapper.querySelectorAll(".lh-rating-preview").forEach(function (el) {
    el.remove();
  });
} else {
  wrapper.querySelectorAll(".lh-rating-live").forEach(function (el) {
    el.remove();
  });
}


wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
  const productJsonEl = form.querySelector(".lh-product-json");
  const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
  if (!productJsonEl || !realSelect) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent || "{}");
  } catch (err) {
    console.error("Parse product JSON failed:", err);
    return;
  }
  if (!Array.isArray(productData.variants) || productData.variants.length === 0) return;

  const selects = form.querySelectorAll(".lh-custom-select");
  const updateVariant = () => {
    const selectedValues = Array.from(selects).map((sel) => {
      const txt = sel.querySelector(".selected-text");
      return txt ? txt.textContent.trim().toLowerCase() : "";
    });

    let matchedVariant = productData.variants.find((v) => {
      const opts = v.options.map((o) => (o ? o.trim().toLowerCase() : ""));
      return opts.every((optVal, i) => optVal === (selectedValues[i] || ""));
    });

    if (!matchedVariant) matchedVariant = productData.variants[0];
 
    realSelect.value = matchedVariant.id;
    realSelect.dispatchEvent(new Event("change", { bubbles: true }));
    
    selects.forEach((sel, i) => {
      const txt = sel.querySelector(".selected-text");
      const opts = sel.querySelectorAll(".lh-option");
      const newVal = matchedVariant.options[i] || "";
      if (txt) txt.textContent = newVal;

      opts.forEach((optEl) => {
        const inputEl = optEl.querySelector("input");
        const optValue = optEl.dataset.value?.trim().toLowerCase() || "";
        if (inputEl) inputEl.checked = optValue === newVal.trim().toLowerCase();
      });
    });
  };

wrapper.querySelectorAll(".lh-swatch-element input[type='radio']").forEach((inputEl) => {
  inputEl.addEventListener("change", (e) => {
    const form = e.target.closest("form.lh-product-box");
    if (!form) return;

    const selects = form.querySelectorAll(".lh-custom-select");
    const optionIndex = e.target.name.replace("option-", "");
    const value = e.target.value;

    const select = Array.from(selects).find(s => s.dataset.optionIndex === optionIndex);
    if (!select) return;

    const txt = select.querySelector(".selected-text");
    const preview = select.querySelector(".w-4.h-4.inline-block");
    const display = select.querySelector(".lh-select-display");

    if (txt) txt.textContent = value;
    if (display) display.setAttribute("aria-label", value);

    const colorKey = value.trim().toLowerCase().replace(/\s+/g, "-");
    if (preview) {
      const useImage = preview.style.backgroundImage.includes("url");
      if (useImage) {
        preview.style.backgroundImage = `var(--lh-swi-${colorKey})`;
      } else {
        preview.style.backgroundColor = `var(--lh-swc-${colorKey})`;
      }
    }

    const swatchWrapper = e.target.closest(".lh-custom-select");
    if (swatchWrapper) {
      const allSwatches = swatchWrapper.querySelectorAll(".lh-swatch-element");
      allSwatches.forEach(sw => sw.classList.remove("active"));
      const parentSw = e.target.closest(".lh-swatch-element");
      if (parentSw) parentSw.classList.add("active");
    }

    updateVariant();

    select.classList.remove("active");
  });
});

  selects.forEach((select) => {
    const display = select.querySelector(".lh-select-display");
    const optionsBox = select.querySelector(".lh-select-options");
    if (!display || !optionsBox) return;

    display.addEventListener("click", (e) => {
    e.stopPropagation();

    const isActive = select.classList.contains("active");

    // Toggle
    if (isActive) {
      select.classList.remove("active");
      optionsBox.classList.remove("open-up");
    } else {
      // Đóng tất cả select khác trước
      wrapper.querySelectorAll(".lh-custom-select.active").forEach((other) => {
        other.classList.remove("active");
        other.querySelector(".lh-select-options")?.classList.remove("open-up");
      });

      select.classList.add("active");

      const rect = optionsBox.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      if (spaceBelow < 100 && spaceAbove > spaceBelow) {
        optionsBox.classList.add("open-up");
      } else {
        optionsBox.classList.remove("open-up");
      }
    }
  });

  optionsBox.querySelectorAll(".lh-option").forEach((opt) => {
    opt.addEventListener("click", (e) => {
      e.stopPropagation();

      const input = opt.querySelector("input");
      if (input) input.checked = true;

      const value = opt.dataset.value || "";
      const txt = select.querySelector(".selected-text");
      const display = select.querySelector(".lh-select-display");
      if (txt) txt.textContent = value;
      if (display) display.setAttribute("aria-label", value);

      select.classList.remove("active");
      optionsBox.classList.remove("open-up");

      updateVariant();
    });
  });
});

wrapper.addEventListener("click", (e) => {
  wrapper.querySelectorAll(".lh-custom-select.active").forEach((sel) => {
    sel.classList.remove("active");
  });
});

  updateVariant();
});

function updateActiveSwatchBackground(select) {
  const display = select.querySelector(".lh-select-display");
  const displayLabel = display?.getAttribute("aria-label");
  const swatches = select.querySelectorAll(".lh-swatch-element");

  swatches.forEach(sw => {
    const input = sw.querySelector("input[type='radio']");
    const label = input?.getAttribute("aria-label");
    if (label && displayLabel && label.trim().toLowerCase() === displayLabel.trim().toLowerCase()) {
      sw.style.background = "#dfdfdfab";
      sw.style.color = "#181818 !important";
      sw.classList.add("active");
    } else {
      sw.style.background = "";
      sw.classList.remove("active");
    }
  });
}

const selects = wrapper.querySelectorAll(".lh-custom-select");

  selects.forEach(select => {
    const firstSwatch = select.querySelector('.lh-swatch-element[data-index="0"]');
    const firstInput = firstSwatch?.querySelector("input[type='radio']");
    const display = select.querySelector(".lh-select-display");

    if (firstSwatch && firstInput && display) {
      const firstLabel = firstInput.getAttribute("aria-label");
      display.setAttribute("aria-label", firstLabel);

      updateActiveSwatchBackground(select);
    }

    const swatches = select.querySelectorAll(".lh-swatch-element");
    swatches.forEach(sw => {
      const input = sw.querySelector("input[type='radio']");
      sw.addEventListener("click", () => {
        const label = input?.getAttribute("aria-label");
        if (label && display) {
          display.setAttribute("aria-label", label);
          updateActiveSwatchBackground(select);
        }
      });
    });
  });



if (mode != 'dev') {
  const bundleBtn = wrapper.querySelector("[data-product-bundle-submit]");
  const bundleMessage = wrapper.querySelector(".lh-error");

  const checkBundleAvailability = () => {
    if (!bundleBtn) return;
    let unavailable = false;

    wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (!variant || !variant.available || Number(variant.price) <= 0) {
        unavailable = true;
      }
    });

    if (unavailable) {
      bundleBtn.disabled = true;
      bundleBtn.classList.add("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "One or more products are sold out or have a price of 0.";
    } else {
      bundleBtn.disabled = false;
      bundleBtn.classList.remove("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "";
    }
  };

  wrapper.querySelectorAll("form.lh-product-box .lh-single-option-selector").forEach((select) => {
    select.addEventListener("change", checkBundleAvailability);
  });

  checkBundleAvailability();

  bundleBtn?.addEventListener("click", async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const spinner = btn.querySelector(".lh-loading__spinner");
    const textSpan = btn.querySelector(".btn-text");

    if (textSpan) textSpan.style.opacity = "0.4";
    spinner?.classList.remove("lh-hidden");
    if (bundleMessage) bundleMessage.textContent = "";

    const forms = wrapper.querySelectorAll("form.lh-product-box");
    const itemsToAdd = [];

    forms.forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const quantityInput = form.querySelector("input[name='quantity']") || { value: 1 };
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (variant && variant.available && Number(variant.price) > 0) {
        itemsToAdd.push({
          id: Number(realSelect.value),
          quantity: Number(quantityInput.value || 1),
        });
      }
    });

    if (itemsToAdd.length === 0) {
      spinner?.classList.add("lh-hidden");
      if (textSpan) textSpan.style.opacity = "1";
      return;
    }

    try {
      for (const item of itemsToAdd) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
      }
      window.location.href = "/cart"; 
    } catch (err) {
      if (bundleMessage) bundleMessage.textContent = "Failed to add bundle to cart.";
    }
  });
}

function reindexProductsAndLookbooks(wrapper) {
  const productItems = Array.from(wrapper.querySelectorAll('.lh-product-index')).filter(Boolean);
  const lookbookItems = Array.from(wrapper.querySelectorAll('.lh-lookbook-index')).filter(Boolean);

  productItems.forEach((item, index) => {
    item.dataset.index = index; 
  });

  lookbookItems.forEach((item, index) => {
    item.dataset.index = index;
  });

  console.log(`🔁 Reindexed: ${productItems.length} products, ${lookbookItems.length} lookbooks`);
}

reindexProductsAndLookbooks(wrapper);

const observerTarget =
  wrapper.querySelector('.lh-slider-container') ||
  wrapper.querySelector('.lh-grid') ||
  wrapper;

const observer = new MutationObserver((mutations) => {
  let shouldReindex = false;

  for (const mutation of mutations) {
    if (
      mutation.type === 'childList' &&
      ([...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) =>
          node.classList?.contains?.('lh-product-index') ||
          node.classList?.contains?.('lh-lookbook-index') ||
          node.querySelector?.('.lh-product-index') ||
          node.querySelector?.('.lh-lookbook-index')
      ))
    ) {
      shouldReindex = true;
      break;
    }
  }

  if (shouldReindex) {
    requestAnimationFrame(() => reindexProductsAndLookbooks(wrapper));
  }
});

observer.observe(observerTarget, {
  childList: true,
  subtree: true,
});






/* LayoutHub assets/lookbook.js */
const slideItems = wrapper.querySelectorAll(".lh-slide-item");
const hotspots = wrapper.querySelectorAll(".lh-hotspot");
const dotsWithImageEl = wrapper.querySelector(".lh-dots-with-image");
let currentIndex = 0;
let lastActiveIndex = Number(wrapper.dataset.lhLastActiveIndex) || 0;

function restoreLastActive() {
  requestAnimationFrame(() => {
    const targetSelector = ".lh-grid-item";
    const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${lastActiveIndex}"]`);
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${lastActiveIndex}"]`);
    if (matchedItem) matchedItem.classList.add("active");
    if (matchedHotspot) matchedHotspot.classList.add("active");
    if (wrapper.embla && !isNaN(lastActiveIndex)) wrapper.embla.scrollTo(Number(lastActiveIndex));
  });
}

const syncGridAndHotspotlook = () => {
  const targetSelector = ".lh-grid-item";
  const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
  const dotSelector = ".lh-slider-pagination-wrapper button";

  const activateHotspotByIndex = (index) => {

    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove("active"));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) {
      matchedHotspot.classList.add("active");
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove("active"));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add("active");
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  wrapper.querySelectorAll(targetSelector).forEach(item => {
    item.addEventListener("click", () => {
      const index = item.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  });

  wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
    hotspot.addEventListener("click", () => {
      const index = hotspot.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);

    });
  });

  wrapper.querySelectorAll(dotSelector).forEach(dot => {
    dot.addEventListener("click", () => {
      const index = dot.dataset.index;
      if (index !== undefined) {
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      }
    });
  });

  const activeItem = wrapper.querySelector(`${targetSelector}.active`);
  if (activeItem) activateHotspotByIndex(activeItem.dataset.index);

  if (wrapper.embla) {
    wrapper.embla.on("select", () => {
      const index = wrapper.embla.selectedScrollSnap();
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  }

  restoreLastActive();
  requestAnimationFrame(() => {
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  });
};
syncGridAndHotspotlook();

slideItems.forEach((slideItem, index) => {
  const hotspot = hotspots[index];
  if (!hotspot) return;
  const productPreview = hotspot.querySelector(".lh-product-preview");
  if (!productPreview) return;
  const updateClone = () => {
    const slideItemClone = slideItem.cloneNode(true);
    productPreview.innerHTML = "";
    productPreview.append(slideItemClone);
    if (mode === "dev") {
      slideItemClone.querySelectorAll("a").forEach(a => {
        a.removeAttribute("href");
        a.addEventListener("click", e => e.preventDefault());
        a.style.cursor = "default";
      });
    }

    restoreLastActive();
    requestAnimationFrame(() => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  };
  updateClone();
  const observer = new MutationObserver(updateClone);
  observer.observe(slideItem, {
    attributes: true,
    attributeFilter: ["class", "style"],
    childList: true,
    subtree: true
  });
});

function adjustPreviewDirection(tooltip, hotspot) {
  if (!tooltip || !hotspot || !dotsWithImageEl) return;

  const minOffset = Number(hotspot.getAttribute("data-tooltip-min-offset")) || 10;
  const gap = 8;
  const containerRect = dotsWithImageEl.getBoundingClientRect();

  const comp = window.getComputedStyle(tooltip);
  const wasHidden =
    comp.display === "none" ||
    comp.visibility === "hidden" ||
    parseFloat(comp.opacity || "1") === 0;

  const prev = {
    display: tooltip.style.display,
    visibility: tooltip.style.visibility,
    opacity: tooltip.style.opacity,
    pointerEvents: tooltip.style.pointerEvents
  };

  if (wasHidden) {
    // tooltip.style.visibility = "hidden";
    tooltip.style.display = "block";
    tooltip.style.opacity = "0";
    tooltip.style.pointerEvents = "none";
  }

  const ttRect = tooltip.getBoundingClientRect();
  const hsRect = hotspot.getBoundingClientRect();

  if (wasHidden) {
    tooltip.style.display = prev.display || "";
    tooltip.style.visibility = prev.visibility || "";
    tooltip.style.opacity = prev.opacity || "";
    tooltip.style.pointerEvents = prev.pointerEvents || "";
  }

  const hsCenterX = hsRect.left + hsRect.width / 2 - containerRect.left;
  const hsCenterY = hsRect.top + hsRect.height / 2 - containerRect.top;
  const ttW = Math.round(ttRect.width);
  const ttH = Math.round(ttRect.height);

  const posFor = dir => {
    if (dir === "top") return { left: hsCenterX - ttW / 2, top: hsRect.top - containerRect.top - ttH - gap };
    if (dir === "bottom") return { left: hsCenterX - ttW / 2, top: hsRect.bottom - containerRect.top + gap };
    if (dir === "left") return { left: hsRect.left - containerRect.left - ttW - gap, top: hsCenterY - ttH / 2 };
    return { left: hsRect.right - containerRect.left + gap, top: hsCenterY - ttH / 2 };
  };

  const fits = dir => {
    const p = posFor(dir);
    return p.left >= minOffset && (p.left + ttW) <= (containerRect.width - minOffset) && p.top >= minOffset && (p.top + ttH) <= (containerRect.height - minOffset);
  };

  const visibleArea = dir => {
    const p = posFor(dir);
    const left = Math.max(0, p.left);
    const top = Math.max(0, p.top);
    const right = Math.max(0, Math.min(containerRect.width, p.left + ttW));
    const bottom = Math.max(0, Math.min(containerRect.height, p.top + ttH));
    const w = Math.max(0, right - left);
    const h = Math.max(0, bottom - top);
    return w * h;
  };

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    const ratioY = hsCenterY / containerRect.height;
    const nearTop = ratioY < 0.45;
    const nearBottom = ratioY > 0.55;

    let dir = "bottom";
    if (nearBottom) dir = "top";

    if (dir === "bottom" && !fits("bottom") && fits("top")) dir = "top";
    if (dir === "top" && !fits("top") && fits("bottom")) dir = "bottom";

    let left = hsCenterX - ttW / 2;

    const imageContentEl = dotsWithImageEl.querySelector(".lh-image-content") || dotsWithImageEl;
    const contentRect = imageContentEl.getBoundingClientRect();
    const contentLeftRel = contentRect.left - containerRect.left + minOffset;
    const contentRightRel = contentRect.right - containerRect.left - minOffset;

    if (left < contentLeftRel) left = contentLeftRel;
    if (left + ttW > contentRightRel) left = contentRightRel - ttW;
    left = Math.max(minOffset, Math.min(left, containerRect.width - ttW - minOffset));

    const parentRect = tooltip.offsetParent ? tooltip.offsetParent.getBoundingClientRect() : containerRect;
    const parentOffsetLeft = parentRect.left - containerRect.left;

    tooltip.style.position = "absolute";
    tooltip.style.left = `${Math.round(left - parentOffsetLeft)}px`;

    if (dir === "bottom") {
      tooltip.style.top = "calc(100% + 24px)";
      tooltip.style.transform = "none";
    } else {
      tooltip.style.top = "calc(-100% - 124px)";
      tooltip.style.transform = "none";
    }

    tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    tooltip.classList.add(`lh-preview-${dir}`);

    return;
  }

  tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
  const ratioX = hsCenterX / containerRect.width;
  const ratioY = hsCenterY / containerRect.height;
  const nearLeft = ratioX < 0.25;
  const nearRight = ratioX > 0.75;
  const nearTop = ratioY < 0.25;
  const nearBottom = ratioY > 0.75;

  if (nearRight && nearBottom) { tooltip.classList.add("lh-preview-bottom-right"); return; }
  if (nearLeft && nearBottom)  { tooltip.classList.add("lh-preview-bottom-left"); return; }
  if (nearRight && nearTop)    { tooltip.classList.add("lh-preview-top-right"); return; }
  if (nearLeft && nearTop)     { tooltip.classList.add("lh-preview-top-left"); return; }
  if (nearRight)               { tooltip.classList.add("lh-preview-left"); return; }
  if (nearLeft)                { tooltip.classList.add("lh-preview-right"); return; }
  if (nearBottom)              { tooltip.classList.add("lh-preview-top"); return; }
  if (nearTop)                 { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("bottom"))          { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("top"))             { tooltip.classList.add("lh-preview-top"); return; }
  if (fits("right"))           { tooltip.classList.add("lh-preview-right"); return; }
  if (fits("left"))            { tooltip.classList.add("lh-preview-left"); return; }

  const areas = { top: visibleArea("top"), bottom: visibleArea("bottom"), left: visibleArea("left"), right: visibleArea("right") };
  const best = Object.keys(areas).sort((a,b)=>areas[b]-areas[a])[0];
  tooltip.classList.add(`lh-preview-${best}`);
}



 
function previewCheck() {
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    const observer = new MutationObserver(() => adjustPreviewDirection(tooltip, hotspot));
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: [
        "data-horizontal-de", "data-vertical-de",
        "data-horizontal-ta", "data-vertical-ta",
        "data-horizontal-mo", "data-vertical-mo",
      ],
    });
    adjustPreviewDirection(tooltip, hotspot);
  });
}
hotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", () => {
    currentIndex = index;
    hotspots.forEach((hs, i) => hs.classList.toggle("active", i === index));
    lastActiveIndex = Number(index);
    wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
  });
});
function handlewrapperClick(e) {
  const clickedHotspot = e.target.closest(".lh-hotspot");
  const clickedPreview = e.target.closest(".lh-product-preview");
  const isSection = e.target.classList.contains("lh-section");
  if (!clickedHotspot && !clickedPreview) {
    if (mode === "dev" && isSection) return;
    hotspots.forEach((hotspot) => hotspot.classList.remove("active"));
    if (typeof closePopup === "function") closePopup();
    else if (typeof closeAllPreviews === "function") closeAllPreviews();
  }
}

function updateOverflowBody() {
  const isMobile = window.innerWidth < 640;
  document.body.style.overflow = (isMobile && isPopupOpen) ? "hidden" : "auto";
}
requestAnimationFrame(previewCheck);
window.addEventListener("resize", () => {
  updateOverflowBody();
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    adjustPreviewDirection(tooltip, hotspot);
  });
});

let isPopupOpen = false;
let activeHotspot = null;

function closeAllPreviews() {
  hotspots.forEach(h => h.classList.remove("active"));
  isPopupOpen = false;
  activeHotspot = null;
  document.body.style.overflow = "auto";
}

hotspots.forEach(hotspot => {
  hotspot.addEventListener("click", (e) => {
    const wasActive = hotspot.classList.contains("active");
    closeAllPreviews();
    if (wasActive) return;

    hotspot.classList.add("active");
    activeHotspot = hotspot;
    isPopupOpen = true;

    // if (window.innerWidth < 768) {
    //   document.body.style.overflow = "hidden";
    // }

    const tooltip = hotspot.querySelector(".lh-product-preview");
    if (tooltip) {
      requestAnimationFrame(() => {
        adjustPreviewDirection(tooltip, hotspot);
      });
    }
  });
});

wrapper.addEventListener("click", (e) => {
  const insideHotspot = e.target.closest(".lh-hotspot");
  const insidePreview = e.target.closest(".lh-product-preview");
  if (!insideHotspot && !insidePreview) {
    closeAllPreviews();
  }
});


const MOBILE_BREAKPOINT = 767;
let currentMode = window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop";

function enableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) return; 
    const tooltip = h.querySelector(".lh-product-preview");
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "class") {
          const isActive = h.classList.contains("active");
          if (isActive) {
            if (tooltip) adjustPreviewDirection(tooltip, h);
            // document.body.style.overflow = "hidden";
            isPopupOpen = true;
            activeHotspot = h;
          } else {
            if (tooltip) {
              tooltip.style.left = "";
              tooltip.style.top = "";
              tooltip.style.position = "";
              tooltip.style.transform = "";
              tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
            }
            document.body.style.overflow = "auto";
            isPopupOpen = false;
            if (activeHotspot === h) activeHotspot = null;
          }
        }
      });
    });
    obs.observe(h, { attributes: true, attributeFilter: ["class"] });
    h._lhMobileObserver = obs;
  });

  if (!document._lhMobileOutside) {
    document._lhMobileOutside = function(e) {
      if (!e.target.closest(".lh-hotspot") && !e.target.closest(".lh-product-preview")) {
        closeAllPreviews();
      }
    };
    document.addEventListener("click", document._lhMobileOutside);
  }
}

function disableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) {
      try { h._lhMobileObserver.disconnect(); } catch (e) {}
      delete h._lhMobileObserver;
    }
    const tooltip = h.querySelector(".lh-product-preview");
    if (tooltip) {
      tooltip.style.left = "";
      tooltip.style.top = "";
      tooltip.style.position = "";
      tooltip.style.transform = "";
      tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    }
  });

  if (document._lhMobileOutside) {
    document.removeEventListener("click", document._lhMobileOutside);
    delete document._lhMobileOutside;
  }
  document.body.style.overflow = "auto";
  isPopupOpen = false;
  activeHotspot = null;
}

if (currentMode === "mobile") {
  enableMobileObservers();
} else {
  previewCheck();
}



/* LayoutHub assets/lh-swatch.js */
const settingsEl = wrapper.querySelector('#money-settings');

let rawFormat = settingsEl?.dataset.format || '{{amount}}';
rawFormat = rawFormat.replace(/&quot;/g, '"').replace(/^"|"$/g, '');
const moneyFormat = rawFormat;
const currency = settingsEl?.dataset.currency || 'USD';

function formatMoney(cents, format = moneyFormat) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = isNaN(cents) ? 0 : parseInt(cents, 10);

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    number = (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  return format.replace(/{{\s*(\w+)\s*}}/g, (match, token) => {
    switch (token) {
      case 'amount': return formatWithDelimiters(cents / 100, 2);
      case 'amount_no_decimals': return formatWithDelimiters(cents / 100, 0);
      case 'amount_with_comma_separator': return formatWithDelimiters(cents / 100, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatWithDelimiters(cents / 100, 0, '.', ',');
      case 'currency': return currency;
      default: return formatWithDelimiters(cents / 100, 2);
    }
  });
}

function updateSwatchThumbnail(productBox, dataSrc) {
  const thumbnail = productBox.querySelector('.lh-product-thumbnail .img-with-variant');
  if (dataSrc && thumbnail) {
    thumbnail.src = dataSrc;
    thumbnail.srcset = dataSrc;
  }
}

wrapper.querySelectorAll('.lh-product-box[data-product-id]').forEach(productBox => {
  const select = productBox.querySelector('.lh-single-option-selector');
  const idInput = productBox.querySelector('[name="id"]');
  const priceEl = productBox.querySelector('.lh-special-price .lh-price');
  const compareEl = productBox.querySelector('.lh-old-price .lh-price');
  const button = productBox.querySelector('.lh-add-to-cart');

  const scriptEl = productBox.querySelector('.lh-product-json');
  if (!scriptEl) return;
  const data = JSON.parse(scriptEl.textContent);
  const variants = data.variants || [];
  const swatches = productBox.querySelectorAll('.lh-swatch');


  // ======= Set Default Variant =======
  swatches.forEach(swatch => {
    const radios = swatch.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const swatchEl = radio.closest('.lh-swatch-element');
      if (!radio.disabled) {
        radio.checked = true;
        if (!swatchEl?.classList.contains('lh-sold-out')) {
          if (swatchEl?.classList.contains('lh-color')) {
            updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
          }
        }
        break;
      }
    }
  });

  updateSelectedVariant();

  productBox.addEventListener('change', e => {
    if (e.target.matches('.lh-swatch-element input[type="radio"]')) {
      updateSelectedVariant();
    }
  });

  productBox.addEventListener('click', e => {
    const swatchEl = e.target.closest('.lh-swatch-element.lh-color');
    if (swatchEl) {
      updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
    }
  });
  function updateSelectedVariant() {
    const selectedOptions = Array.from(swatches).map(swatch =>
      swatch.querySelector('input[type="radio"]:checked')?.value.trim() || ''
    );

    const matchedVariant = variants.find(v =>
      Array.isArray(v.options) &&
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!matchedVariant) return;
    updateVariantPrice(productBox, matchedVariant);

    
    updateVariantPrice(productBox, matchedVariant);

    const contactText = document.querySelector('.data-tex-locales')?.dataset.textContact || 'Contact';

    // Update Inputs
    if (idInput) idInput.value = matchedVariant.id;
    if (select) {
      select.value = matchedVariant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update Price
    if (priceEl) {
      priceEl.innerHTML = matchedVariant.price === 0
        ? contactText
        : formatMoney(matchedVariant.price, moneyFormat);
    }

    if (compareEl) {
      compareEl.innerHTML =
        matchedVariant.compare_at_price > matchedVariant.price && matchedVariant.price > 0
          ? formatMoney(matchedVariant.compare_at_price, moneyFormat)
          : '';
    }

    // Update Button

    if (button && idInput) {
      let productLabels = {};
      const labelScript = wrapper.querySelector('#product-button-labels');

      try {
        productLabels = JSON.parse(labelScript?.textContent || '{}');
      } catch (e) {
        console.warn('Failed to parse product labels:', e);
      }

      const isContact = matchedVariant.price === 0;
      const isAvailable = matchedVariant.available;
      const shouldDisable = isContact || !isAvailable;
      button.disabled = shouldDisable;
      button.style.pointerEvents = shouldDisable ? 'none' : 'auto';
      const span = button.querySelector('span');
      if (span) {
        if (!isAvailable) {
          span.textContent = productLabels.inventoryOutOfStock || 'Out of stock';
        } else if (isContact) {
          span.textContent = productLabels.chooseOptions || 'Choose options';
        } else {
          span.textContent = productLabels.addToCart || 'Add to cart';
        }
      }

      button.addEventListener('click', (e) => {
        const variantId = parseInt(idInput.value, 10);
        const variant = variants.find(v => v.id === variantId);
        if (!variant || variant.price === 0 || !variant.available) {
          e.preventDefault();
        }
      });
    }



    // Disable unavailable swatches
    swatches.forEach((swatch, index) => {
      const radios = swatch.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const value = radio.value.trim();
        const testOptions = [...selectedOptions];
        testOptions[index] = value;

        const available = variants.some(v =>
          v.available && v.options.every((opt, i) => opt === testOptions[i])
        );

        const swatchEl = radio.closest('.lh-swatch-element');
        swatchEl?.classList.toggle('lh-sold-out', !available);
      });
    });
  }

});


const bundleSubmitBtn = wrapper.querySelector("[data-product-bundle-submit]");
if (mode !== "dev") {
  if (bundleSubmitBtn) {
    bundleSubmitBtn.addEventListener("click", () => {
      if (bundleState.items.length === 0) return;

      const itemsToAdd = bundleState.items.map((i) => ({
        id: i.variantId,
        quantity: i.quantity,
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      })
        .then((res) => res.json())
        .then(() => {
          bundleState.items = [];
          renderBundle();
          updateBundleTotal();

          if (typeof window.showCartDrawer === "function") {
            window.showCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((err) => console.error(err));
    });
  }
} 

function updateVariantPrice(wrapper, variant) {
  const priceBox = wrapper.querySelector('.lh-price-box');
  if (!priceBox) return;

  const currentPriceEl = priceBox.querySelector('.lh-current-price');
  const oldPriceEl = priceBox.querySelector('.lh-old-price');

  const formattedPrice = formatMoney(variant.price, moneyFormat);
  const formattedCompare = variant.compare_at_price
    ? formatMoney(variant.compare_at_price, moneyFormat)
    : '';

  if (currentPriceEl) currentPriceEl.textContent = formattedPrice;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (oldPriceEl) {
      oldPriceEl.textContent = formattedCompare;
      oldPriceEl.style.display = 'inline';
    } else {
      const span = document.createElement('span');
      span.className = 'lh-old-price line-through !text-[var(--lh-other-sale-price-color)] lh-p2';
      span.textContent = formattedCompare;
      priceBox.appendChild(span);
    }
  } else if (oldPriceEl) {
    oldPriceEl.style.display = 'none';
  }
}



})(document.querySelector('section.lh-qewa4p'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
setTimeout(() => {
  window.LayoutHubSlider(wrapper);
}, 50);

})(document.querySelector('section.lh-xmw5o6'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
window.LayoutHubSlider(wrapper);

wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    const url = this.dataset.url;
    if (url) {
      window.location.href = url;
    }
  });
});


const syncGridAndHotspot = () => {
  const targetSelector = '.lh-grid-item';
  const hotspotSelector = '.lh-dots-with-image .lh-hotspot';
  const dotSelector = '.lh-slider-pagination-wrapper button';

  const activateHotspotByIndex = (index) => {
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) matchedHotspot.classList.add('active');
    markActiveItem();
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('active'));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add('active');
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
    }
    markActiveItem();
  };

  const markActiveItem = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove('activeItem'));
    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove('active'));

    const totalItems = wrapper.querySelectorAll(targetSelector).length;
    const activeItems = Array.from(wrapper.querySelectorAll(`${targetSelector}.active`));

    if (totalItems <= 2) {
      wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.add('active'));
      if (activeItems.length) {
        activeItems.forEach(item => item.classList.add('activeItem'));
      }
      return;
    }

    if (activeItems.length === 1) {
      activeItems[0].classList.add('activeItem');

      const index = activeItems[0].dataset.index;
      const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
      if (matchedHotspot) matchedHotspot.classList.add('active');
    } else if (activeItems.length > 1) {
      const indexes = activeItems.map(el => Number(el.dataset.index)).sort((a, b) => a - b);
      const firstIndex = indexes[0];
      const lastIndex = indexes[indexes.length - 1];

      let chosenIndex;
      if (firstIndex === 0 && lastIndex === totalItems - 1) {
        chosenIndex = lastIndex;
      } else {
        chosenIndex = firstIndex;
      }

      const chosenItem = activeItems.find(el => Number(el.dataset.index) === chosenIndex);
      if (chosenItem) {
        chosenItem.classList.add('activeItem');

        const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${chosenIndex}"]`);
        if (matchedHotspot) matchedHotspot.classList.add('active');
      }
    }
  };

  const setupGridClick = () => {
    wrapper.querySelectorAll(targetSelector).forEach(item => {
      item.addEventListener('click', () => {
        const index = item.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupHotspotClick = () => {
    wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = hotspot.dataset.index;
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      });
    });
  };

  const setupDotClick = () => {
    wrapper.querySelectorAll(dotSelector).forEach(dot => {
      dot.addEventListener('click', () => {
        const index = dot.dataset.index;
        if (index !== undefined) {
          activateItemByIndex(index);
          activateHotspotByIndex(index);
        }
      });
    });
  };

  const syncInitialState = () => {
    const activeItem = wrapper.querySelector(`${targetSelector}.active`);
    if (activeItem) {
      activateHotspotByIndex(activeItem.dataset.index);
    }
    markActiveItem();
  };

  if (wrapper.embla) {
    wrapper.embla.on('select', () => {
      markActiveItem();
    });
  }

  setupGridClick();
  setupHotspotClick();
  setupDotClick();
  syncInitialState();
};

syncGridAndHotspot();

if (mode != 'dev') {
  wrapper.querySelectorAll('.lh-btn-options[data-url]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const url = this.dataset.url;
      if (url) {
        window.location.href = url;
      }
    });
  });
  wrapper.querySelectorAll(".lh-rating-preview").forEach(function (el) {
    el.remove();
  });
} else {
  wrapper.querySelectorAll(".lh-rating-live").forEach(function (el) {
    el.remove();
  });
}


wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
  const productJsonEl = form.querySelector(".lh-product-json");
  const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
  if (!productJsonEl || !realSelect) return;

  let productData;
  try {
    productData = JSON.parse(productJsonEl.textContent || "{}");
  } catch (err) {
    console.error("Parse product JSON failed:", err);
    return;
  }
  if (!Array.isArray(productData.variants) || productData.variants.length === 0) return;

  const selects = form.querySelectorAll(".lh-custom-select");
  const updateVariant = () => {
    const selectedValues = Array.from(selects).map((sel) => {
      const txt = sel.querySelector(".selected-text");
      return txt ? txt.textContent.trim().toLowerCase() : "";
    });

    let matchedVariant = productData.variants.find((v) => {
      const opts = v.options.map((o) => (o ? o.trim().toLowerCase() : ""));
      return opts.every((optVal, i) => optVal === (selectedValues[i] || ""));
    });

    if (!matchedVariant) matchedVariant = productData.variants[0];
 
    realSelect.value = matchedVariant.id;
    realSelect.dispatchEvent(new Event("change", { bubbles: true }));
    
    selects.forEach((sel, i) => {
      const txt = sel.querySelector(".selected-text");
      const opts = sel.querySelectorAll(".lh-option");
      const newVal = matchedVariant.options[i] || "";
      if (txt) txt.textContent = newVal;

      opts.forEach((optEl) => {
        const inputEl = optEl.querySelector("input");
        const optValue = optEl.dataset.value?.trim().toLowerCase() || "";
        if (inputEl) inputEl.checked = optValue === newVal.trim().toLowerCase();
      });
    });
  };

wrapper.querySelectorAll(".lh-swatch-element input[type='radio']").forEach((inputEl) => {
  inputEl.addEventListener("change", (e) => {
    const form = e.target.closest("form.lh-product-box");
    if (!form) return;

    const selects = form.querySelectorAll(".lh-custom-select");
    const optionIndex = e.target.name.replace("option-", "");
    const value = e.target.value;

    const select = Array.from(selects).find(s => s.dataset.optionIndex === optionIndex);
    if (!select) return;

    const txt = select.querySelector(".selected-text");
    const preview = select.querySelector(".w-4.h-4.inline-block");
    const display = select.querySelector(".lh-select-display");

    if (txt) txt.textContent = value;
    if (display) display.setAttribute("aria-label", value);

    const colorKey = value.trim().toLowerCase().replace(/\s+/g, "-");
    if (preview) {
      const useImage = preview.style.backgroundImage.includes("url");
      if (useImage) {
        preview.style.backgroundImage = `var(--lh-swi-${colorKey})`;
      } else {
        preview.style.backgroundColor = `var(--lh-swc-${colorKey})`;
      }
    }

    const swatchWrapper = e.target.closest(".lh-custom-select");
    if (swatchWrapper) {
      const allSwatches = swatchWrapper.querySelectorAll(".lh-swatch-element");
      allSwatches.forEach(sw => sw.classList.remove("active"));
      const parentSw = e.target.closest(".lh-swatch-element");
      if (parentSw) parentSw.classList.add("active");
    }

    updateVariant();

    select.classList.remove("active");
  });
});

  selects.forEach((select) => {
    const display = select.querySelector(".lh-select-display");
    const optionsBox = select.querySelector(".lh-select-options");
    if (!display || !optionsBox) return;

    display.addEventListener("click", (e) => {
    e.stopPropagation();

    const isActive = select.classList.contains("active");

    // Toggle
    if (isActive) {
      select.classList.remove("active");
      optionsBox.classList.remove("open-up");
    } else {
      // Đóng tất cả select khác trước
      wrapper.querySelectorAll(".lh-custom-select.active").forEach((other) => {
        other.classList.remove("active");
        other.querySelector(".lh-select-options")?.classList.remove("open-up");
      });

      select.classList.add("active");

      const rect = optionsBox.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      if (spaceBelow < 100 && spaceAbove > spaceBelow) {
        optionsBox.classList.add("open-up");
      } else {
        optionsBox.classList.remove("open-up");
      }
    }
  });

  optionsBox.querySelectorAll(".lh-option").forEach((opt) => {
    opt.addEventListener("click", (e) => {
      e.stopPropagation();

      const input = opt.querySelector("input");
      if (input) input.checked = true;

      const value = opt.dataset.value || "";
      const txt = select.querySelector(".selected-text");
      const display = select.querySelector(".lh-select-display");
      if (txt) txt.textContent = value;
      if (display) display.setAttribute("aria-label", value);

      select.classList.remove("active");
      optionsBox.classList.remove("open-up");

      updateVariant();
    });
  });
});

wrapper.addEventListener("click", (e) => {
  wrapper.querySelectorAll(".lh-custom-select.active").forEach((sel) => {
    sel.classList.remove("active");
  });
});

  updateVariant();
});

function updateActiveSwatchBackground(select) {
  const display = select.querySelector(".lh-select-display");
  const displayLabel = display?.getAttribute("aria-label");
  const swatches = select.querySelectorAll(".lh-swatch-element");

  swatches.forEach(sw => {
    const input = sw.querySelector("input[type='radio']");
    const label = input?.getAttribute("aria-label");
    if (label && displayLabel && label.trim().toLowerCase() === displayLabel.trim().toLowerCase()) {
      sw.style.background = "#dfdfdfab";
      sw.style.color = "#181818 !important";
      sw.classList.add("active");
    } else {
      sw.style.background = "";
      sw.classList.remove("active");
    }
  });
}

const selects = wrapper.querySelectorAll(".lh-custom-select");

  selects.forEach(select => {
    const firstSwatch = select.querySelector('.lh-swatch-element[data-index="0"]');
    const firstInput = firstSwatch?.querySelector("input[type='radio']");
    const display = select.querySelector(".lh-select-display");

    if (firstSwatch && firstInput && display) {
      const firstLabel = firstInput.getAttribute("aria-label");
      display.setAttribute("aria-label", firstLabel);

      updateActiveSwatchBackground(select);
    }

    const swatches = select.querySelectorAll(".lh-swatch-element");
    swatches.forEach(sw => {
      const input = sw.querySelector("input[type='radio']");
      sw.addEventListener("click", () => {
        const label = input?.getAttribute("aria-label");
        if (label && display) {
          display.setAttribute("aria-label", label);
          updateActiveSwatchBackground(select);
        }
      });
    });
  });



if (mode != 'dev') {
  const bundleBtn = wrapper.querySelector("[data-product-bundle-submit]");
  const bundleMessage = wrapper.querySelector(".lh-error");

  const checkBundleAvailability = () => {
    if (!bundleBtn) return;
    let unavailable = false;

    wrapper.querySelectorAll("form.lh-product-box").forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (!variant || !variant.available || Number(variant.price) <= 0) {
        unavailable = true;
      }
    });

    if (unavailable) {
      bundleBtn.disabled = true;
      bundleBtn.classList.add("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "One or more products are sold out or have a price of 0.";
    } else {
      bundleBtn.disabled = false;
      bundleBtn.classList.remove("opacity-50", "cursor-not-allowed");
      if (bundleMessage) bundleMessage.textContent = "";
    }
  };

  wrapper.querySelectorAll("form.lh-product-box .lh-single-option-selector").forEach((select) => {
    select.addEventListener("change", checkBundleAvailability);
  });

  checkBundleAvailability();

  bundleBtn?.addEventListener("click", async (e) => {
    e.preventDefault();
    const btn = e.currentTarget;
    const spinner = btn.querySelector(".lh-loading__spinner");
    const textSpan = btn.querySelector(".btn-text");

    if (textSpan) textSpan.style.opacity = "0.4";
    spinner?.classList.remove("lh-hidden");
    if (bundleMessage) bundleMessage.textContent = "";

    const forms = wrapper.querySelectorAll("form.lh-product-box");
    const itemsToAdd = [];

    forms.forEach((form) => {
      const realSelect = form.querySelector(".lh-single-option-selector[name='id']");
      const quantityInput = form.querySelector("input[name='quantity']") || { value: 1 };
      const productJsonEl = form.querySelector(".lh-product-json");

      if (!realSelect || !productJsonEl) return;

      let productData;
      try {
        productData = JSON.parse(productJsonEl.textContent || "{}");
      } catch {
        return;
      }

      const variant = productData.variants.find((v) => v.id == Number(realSelect.value));
      if (variant && variant.available && Number(variant.price) > 0) {
        itemsToAdd.push({
          id: Number(realSelect.value),
          quantity: Number(quantityInput.value || 1),
        });
      }
    });

    if (itemsToAdd.length === 0) {
      spinner?.classList.add("lh-hidden");
      if (textSpan) textSpan.style.opacity = "1";
      return;
    }

    try {
      for (const item of itemsToAdd) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
      }
      window.location.href = "/cart"; 
    } catch (err) {
      if (bundleMessage) bundleMessage.textContent = "Failed to add bundle to cart.";
    }
  });
}

function reindexProductsAndLookbooks(wrapper) {
  const productItems = Array.from(wrapper.querySelectorAll('.lh-product-index')).filter(Boolean);
  const lookbookItems = Array.from(wrapper.querySelectorAll('.lh-lookbook-index')).filter(Boolean);

  productItems.forEach((item, index) => {
    item.dataset.index = index; 
  });

  lookbookItems.forEach((item, index) => {
    item.dataset.index = index;
  });

  console.log(`🔁 Reindexed: ${productItems.length} products, ${lookbookItems.length} lookbooks`);
}

reindexProductsAndLookbooks(wrapper);

const observerTarget =
  wrapper.querySelector('.lh-slider-container') ||
  wrapper.querySelector('.lh-grid') ||
  wrapper;

const observer = new MutationObserver((mutations) => {
  let shouldReindex = false;

  for (const mutation of mutations) {
    if (
      mutation.type === 'childList' &&
      ([...mutation.addedNodes, ...mutation.removedNodes].some(
        (node) =>
          node.classList?.contains?.('lh-product-index') ||
          node.classList?.contains?.('lh-lookbook-index') ||
          node.querySelector?.('.lh-product-index') ||
          node.querySelector?.('.lh-lookbook-index')
      ))
    ) {
      shouldReindex = true;
      break;
    }
  }

  if (shouldReindex) {
    requestAnimationFrame(() => reindexProductsAndLookbooks(wrapper));
  }
});

observer.observe(observerTarget, {
  childList: true,
  subtree: true,
});






/* LayoutHub assets/lookbook.js */
const slideItems = wrapper.querySelectorAll(".lh-slide-item");
const hotspots = wrapper.querySelectorAll(".lh-hotspot");
const dotsWithImageEl = wrapper.querySelector(".lh-dots-with-image");
let currentIndex = 0;
let lastActiveIndex = Number(wrapper.dataset.lhLastActiveIndex) || 0;

function restoreLastActive() {
  requestAnimationFrame(() => {
    const targetSelector = ".lh-grid-item";
    const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${lastActiveIndex}"]`);
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${lastActiveIndex}"]`);
    if (matchedItem) matchedItem.classList.add("active");
    if (matchedHotspot) matchedHotspot.classList.add("active");
    if (wrapper.embla && !isNaN(lastActiveIndex)) wrapper.embla.scrollTo(Number(lastActiveIndex));
  });
}

const syncGridAndHotspotlook = () => {
  const targetSelector = ".lh-grid-item";
  const hotspotSelector = ".lh-dots-with-image .lh-hotspot";
  const dotSelector = ".lh-slider-pagination-wrapper button";

  const activateHotspotByIndex = (index) => {

    wrapper.querySelectorAll(hotspotSelector).forEach(h => h.classList.remove("active"));
    const matchedHotspot = wrapper.querySelector(`${hotspotSelector}[data-index="${index}"]`);
    if (matchedHotspot) {
      matchedHotspot.classList.add("active");
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  const activateItemByIndex = (index) => {
    wrapper.querySelectorAll(targetSelector).forEach(item => item.classList.remove("active"));
    const matchedItem = wrapper.querySelector(`${targetSelector}[data-index="${index}"]`);
    if (matchedItem) {
      matchedItem.classList.add("active");
      if (wrapper.embla) wrapper.embla.scrollTo(Number(index));
      lastActiveIndex = Number(index);
      wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
    }
  };

  wrapper.querySelectorAll(targetSelector).forEach(item => {
    item.addEventListener("click", () => {
      const index = item.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  });

  wrapper.querySelectorAll(hotspotSelector).forEach(hotspot => {
    hotspot.addEventListener("click", () => {
      const index = hotspot.dataset.index;
      activateItemByIndex(index);
      activateHotspotByIndex(index);

    });
  });

  wrapper.querySelectorAll(dotSelector).forEach(dot => {
    dot.addEventListener("click", () => {
      const index = dot.dataset.index;
      if (index !== undefined) {
        activateItemByIndex(index);
        activateHotspotByIndex(index);
      }
    });
  });

  const activeItem = wrapper.querySelector(`${targetSelector}.active`);
  if (activeItem) activateHotspotByIndex(activeItem.dataset.index);

  if (wrapper.embla) {
    wrapper.embla.on("select", () => {
      const index = wrapper.embla.selectedScrollSnap();
      activateItemByIndex(index);
      activateHotspotByIndex(index);
    });
  }

  restoreLastActive();
  requestAnimationFrame(() => {
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  });
};
syncGridAndHotspotlook();

slideItems.forEach((slideItem, index) => {
  const hotspot = hotspots[index];
  if (!hotspot) return;
  const productPreview = hotspot.querySelector(".lh-product-preview");
  if (!productPreview) return;
  const updateClone = () => {
    const slideItemClone = slideItem.cloneNode(true);
    productPreview.innerHTML = "";
    productPreview.append(slideItemClone);
    if (mode === "dev") {
      slideItemClone.querySelectorAll("a").forEach(a => {
        a.removeAttribute("href");
        a.addEventListener("click", e => e.preventDefault());
        a.style.cursor = "default";
      });
    }

    restoreLastActive();
    requestAnimationFrame(() => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  };
  updateClone();
  const observer = new MutationObserver(updateClone);
  observer.observe(slideItem, {
    attributes: true,
    attributeFilter: ["class", "style"],
    childList: true,
    subtree: true
  });
});

function adjustPreviewDirection(tooltip, hotspot) {
  if (!tooltip || !hotspot || !dotsWithImageEl) return;

  const minOffset = Number(hotspot.getAttribute("data-tooltip-min-offset")) || 10;
  const gap = 8;
  const containerRect = dotsWithImageEl.getBoundingClientRect();

  const comp = window.getComputedStyle(tooltip);
  const wasHidden =
    comp.display === "none" ||
    comp.visibility === "hidden" ||
    parseFloat(comp.opacity || "1") === 0;

  const prev = {
    display: tooltip.style.display,
    visibility: tooltip.style.visibility,
    opacity: tooltip.style.opacity,
    pointerEvents: tooltip.style.pointerEvents
  };

  if (wasHidden) {
    // tooltip.style.visibility = "hidden";
    tooltip.style.display = "block";
    tooltip.style.opacity = "0";
    tooltip.style.pointerEvents = "none";
  }

  const ttRect = tooltip.getBoundingClientRect();
  const hsRect = hotspot.getBoundingClientRect();

  if (wasHidden) {
    tooltip.style.display = prev.display || "";
    tooltip.style.visibility = prev.visibility || "";
    tooltip.style.opacity = prev.opacity || "";
    tooltip.style.pointerEvents = prev.pointerEvents || "";
  }

  const hsCenterX = hsRect.left + hsRect.width / 2 - containerRect.left;
  const hsCenterY = hsRect.top + hsRect.height / 2 - containerRect.top;
  const ttW = Math.round(ttRect.width);
  const ttH = Math.round(ttRect.height);

  const posFor = dir => {
    if (dir === "top") return { left: hsCenterX - ttW / 2, top: hsRect.top - containerRect.top - ttH - gap };
    if (dir === "bottom") return { left: hsCenterX - ttW / 2, top: hsRect.bottom - containerRect.top + gap };
    if (dir === "left") return { left: hsRect.left - containerRect.left - ttW - gap, top: hsCenterY - ttH / 2 };
    return { left: hsRect.right - containerRect.left + gap, top: hsCenterY - ttH / 2 };
  };

  const fits = dir => {
    const p = posFor(dir);
    return p.left >= minOffset && (p.left + ttW) <= (containerRect.width - minOffset) && p.top >= minOffset && (p.top + ttH) <= (containerRect.height - minOffset);
  };

  const visibleArea = dir => {
    const p = posFor(dir);
    const left = Math.max(0, p.left);
    const top = Math.max(0, p.top);
    const right = Math.max(0, Math.min(containerRect.width, p.left + ttW));
    const bottom = Math.max(0, Math.min(containerRect.height, p.top + ttH));
    const w = Math.max(0, right - left);
    const h = Math.max(0, bottom - top);
    return w * h;
  };

  const isMobile = window.matchMedia("(max-width: 767px)").matches;

  if (isMobile) {
    const ratioY = hsCenterY / containerRect.height;
    const nearTop = ratioY < 0.45;
    const nearBottom = ratioY > 0.55;

    let dir = "bottom";
    if (nearBottom) dir = "top";

    if (dir === "bottom" && !fits("bottom") && fits("top")) dir = "top";
    if (dir === "top" && !fits("top") && fits("bottom")) dir = "bottom";

    let left = hsCenterX - ttW / 2;

    const imageContentEl = dotsWithImageEl.querySelector(".lh-image-content") || dotsWithImageEl;
    const contentRect = imageContentEl.getBoundingClientRect();
    const contentLeftRel = contentRect.left - containerRect.left + minOffset;
    const contentRightRel = contentRect.right - containerRect.left - minOffset;

    if (left < contentLeftRel) left = contentLeftRel;
    if (left + ttW > contentRightRel) left = contentRightRel - ttW;
    left = Math.max(minOffset, Math.min(left, containerRect.width - ttW - minOffset));

    const parentRect = tooltip.offsetParent ? tooltip.offsetParent.getBoundingClientRect() : containerRect;
    const parentOffsetLeft = parentRect.left - containerRect.left;

    tooltip.style.position = "absolute";
    tooltip.style.left = `${Math.round(left - parentOffsetLeft)}px`;

    if (dir === "bottom") {
      tooltip.style.top = "calc(100% + 24px)";
      tooltip.style.transform = "none";
    } else {
      tooltip.style.top = "calc(-100% - 124px)";
      tooltip.style.transform = "none";
    }

    tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    tooltip.classList.add(`lh-preview-${dir}`);

    return;
  }

  tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
  const ratioX = hsCenterX / containerRect.width;
  const ratioY = hsCenterY / containerRect.height;
  const nearLeft = ratioX < 0.25;
  const nearRight = ratioX > 0.75;
  const nearTop = ratioY < 0.25;
  const nearBottom = ratioY > 0.75;

  if (nearRight && nearBottom) { tooltip.classList.add("lh-preview-bottom-right"); return; }
  if (nearLeft && nearBottom)  { tooltip.classList.add("lh-preview-bottom-left"); return; }
  if (nearRight && nearTop)    { tooltip.classList.add("lh-preview-top-right"); return; }
  if (nearLeft && nearTop)     { tooltip.classList.add("lh-preview-top-left"); return; }
  if (nearRight)               { tooltip.classList.add("lh-preview-left"); return; }
  if (nearLeft)                { tooltip.classList.add("lh-preview-right"); return; }
  if (nearBottom)              { tooltip.classList.add("lh-preview-top"); return; }
  if (nearTop)                 { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("bottom"))          { tooltip.classList.add("lh-preview-bottom"); return; }
  if (fits("top"))             { tooltip.classList.add("lh-preview-top"); return; }
  if (fits("right"))           { tooltip.classList.add("lh-preview-right"); return; }
  if (fits("left"))            { tooltip.classList.add("lh-preview-left"); return; }

  const areas = { top: visibleArea("top"), bottom: visibleArea("bottom"), left: visibleArea("left"), right: visibleArea("right") };
  const best = Object.keys(areas).sort((a,b)=>areas[b]-areas[a])[0];
  tooltip.classList.add(`lh-preview-${best}`);
}



 
function previewCheck() {
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    const observer = new MutationObserver(() => adjustPreviewDirection(tooltip, hotspot));
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: [
        "data-horizontal-de", "data-vertical-de",
        "data-horizontal-ta", "data-vertical-ta",
        "data-horizontal-mo", "data-vertical-mo",
      ],
    });
    adjustPreviewDirection(tooltip, hotspot);
  });
}
hotspots.forEach((hotspot, index) => {
  hotspot.addEventListener("click", () => {
    currentIndex = index;
    hotspots.forEach((hs, i) => hs.classList.toggle("active", i === index));
    lastActiveIndex = Number(index);
    wrapper.dataset.lhLastActiveIndex = String(lastActiveIndex);
  });
});
function handlewrapperClick(e) {
  const clickedHotspot = e.target.closest(".lh-hotspot");
  const clickedPreview = e.target.closest(".lh-product-preview");
  const isSection = e.target.classList.contains("lh-section");
  if (!clickedHotspot && !clickedPreview) {
    if (mode === "dev" && isSection) return;
    hotspots.forEach((hotspot) => hotspot.classList.remove("active"));
    if (typeof closePopup === "function") closePopup();
    else if (typeof closeAllPreviews === "function") closeAllPreviews();
  }
}

function updateOverflowBody() {
  const isMobile = window.innerWidth < 640;
  document.body.style.overflow = (isMobile && isPopupOpen) ? "hidden" : "auto";
}
requestAnimationFrame(previewCheck);
window.addEventListener("resize", () => {
  updateOverflowBody();
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    adjustPreviewDirection(tooltip, hotspot);
  });
});

let isPopupOpen = false;
let activeHotspot = null;

function closeAllPreviews() {
  hotspots.forEach(h => h.classList.remove("active"));
  isPopupOpen = false;
  activeHotspot = null;
  document.body.style.overflow = "auto";
}

hotspots.forEach(hotspot => {
  hotspot.addEventListener("click", (e) => {
    const wasActive = hotspot.classList.contains("active");
    closeAllPreviews();
    if (wasActive) return;

    hotspot.classList.add("active");
    activeHotspot = hotspot;
    isPopupOpen = true;

    // if (window.innerWidth < 768) {
    //   document.body.style.overflow = "hidden";
    // }

    const tooltip = hotspot.querySelector(".lh-product-preview");
    if (tooltip) {
      requestAnimationFrame(() => {
        adjustPreviewDirection(tooltip, hotspot);
      });
    }
  });
});

wrapper.addEventListener("click", (e) => {
  const insideHotspot = e.target.closest(".lh-hotspot");
  const insidePreview = e.target.closest(".lh-product-preview");
  if (!insideHotspot && !insidePreview) {
    closeAllPreviews();
  }
});


const MOBILE_BREAKPOINT = 767;
let currentMode = window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop";

function enableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) return; 
    const tooltip = h.querySelector(".lh-product-preview");
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "class") {
          const isActive = h.classList.contains("active");
          if (isActive) {
            if (tooltip) adjustPreviewDirection(tooltip, h);
            // document.body.style.overflow = "hidden";
            isPopupOpen = true;
            activeHotspot = h;
          } else {
            if (tooltip) {
              tooltip.style.left = "";
              tooltip.style.top = "";
              tooltip.style.position = "";
              tooltip.style.transform = "";
              tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
            }
            document.body.style.overflow = "auto";
            isPopupOpen = false;
            if (activeHotspot === h) activeHotspot = null;
          }
        }
      });
    });
    obs.observe(h, { attributes: true, attributeFilter: ["class"] });
    h._lhMobileObserver = obs;
  });

  if (!document._lhMobileOutside) {
    document._lhMobileOutside = function(e) {
      if (!e.target.closest(".lh-hotspot") && !e.target.closest(".lh-product-preview")) {
        closeAllPreviews();
      }
    };
    document.addEventListener("click", document._lhMobileOutside);
  }
}

function disableMobileObservers() {
  hotspots.forEach(h => {
    if (h._lhMobileObserver) {
      try { h._lhMobileObserver.disconnect(); } catch (e) {}
      delete h._lhMobileObserver;
    }
    const tooltip = h.querySelector(".lh-product-preview");
    if (tooltip) {
      tooltip.style.left = "";
      tooltip.style.top = "";
      tooltip.style.position = "";
      tooltip.style.transform = "";
      tooltip.className = tooltip.className.replace(/\blh-preview-\S+/g, "").trim();
    }
  });

  if (document._lhMobileOutside) {
    document.removeEventListener("click", document._lhMobileOutside);
    delete document._lhMobileOutside;
  }
  document.body.style.overflow = "auto";
  isPopupOpen = false;
  activeHotspot = null;
}

if (currentMode === "mobile") {
  enableMobileObservers();
} else {
  previewCheck();
}



/* LayoutHub assets/lh-swatch.js */
const settingsEl = wrapper.querySelector('#money-settings');

let rawFormat = settingsEl?.dataset.format || '{{amount}}';
rawFormat = rawFormat.replace(/&quot;/g, '"').replace(/^"|"$/g, '');
const moneyFormat = rawFormat;
const currency = settingsEl?.dataset.currency || 'USD';

function formatMoney(cents, format = moneyFormat) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = isNaN(cents) ? 0 : parseInt(cents, 10);

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    number = (Math.round(number * Math.pow(10, precision)) / Math.pow(10, precision)).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return dollars + (parts[1] ? decimal + parts[1] : '');
  }

  return format.replace(/{{\s*(\w+)\s*}}/g, (match, token) => {
    switch (token) {
      case 'amount': return formatWithDelimiters(cents / 100, 2);
      case 'amount_no_decimals': return formatWithDelimiters(cents / 100, 0);
      case 'amount_with_comma_separator': return formatWithDelimiters(cents / 100, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatWithDelimiters(cents / 100, 0, '.', ',');
      case 'currency': return currency;
      default: return formatWithDelimiters(cents / 100, 2);
    }
  });
}

function updateSwatchThumbnail(productBox, dataSrc) {
  const thumbnail = productBox.querySelector('.lh-product-thumbnail .img-with-variant');
  if (dataSrc && thumbnail) {
    thumbnail.src = dataSrc;
    thumbnail.srcset = dataSrc;
  }
}

wrapper.querySelectorAll('.lh-product-box[data-product-id]').forEach(productBox => {
  const select = productBox.querySelector('.lh-single-option-selector');
  const idInput = productBox.querySelector('[name="id"]');
  const priceEl = productBox.querySelector('.lh-special-price .lh-price');
  const compareEl = productBox.querySelector('.lh-old-price .lh-price');
  const button = productBox.querySelector('.lh-add-to-cart');

  const scriptEl = productBox.querySelector('.lh-product-json');
  if (!scriptEl) return;
  const data = JSON.parse(scriptEl.textContent);
  const variants = data.variants || [];
  const swatches = productBox.querySelectorAll('.lh-swatch');


  // ======= Set Default Variant =======
  swatches.forEach(swatch => {
    const radios = swatch.querySelectorAll('input[type="radio"]');
    for (const radio of radios) {
      const swatchEl = radio.closest('.lh-swatch-element');
      if (!radio.disabled) {
        radio.checked = true;
        if (!swatchEl?.classList.contains('lh-sold-out')) {
          if (swatchEl?.classList.contains('lh-color')) {
            updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
          }
        }
        break;
      }
    }
  });

  updateSelectedVariant();

  productBox.addEventListener('change', e => {
    if (e.target.matches('.lh-swatch-element input[type="radio"]')) {
      updateSelectedVariant();
    }
  });

  productBox.addEventListener('click', e => {
    const swatchEl = e.target.closest('.lh-swatch-element.lh-color');
    if (swatchEl) {
      updateSwatchThumbnail(productBox, swatchEl.getAttribute('data-src'));
    }
  });
  function updateSelectedVariant() {
    const selectedOptions = Array.from(swatches).map(swatch =>
      swatch.querySelector('input[type="radio"]:checked')?.value.trim() || ''
    );

    const matchedVariant = variants.find(v =>
      Array.isArray(v.options) &&
      v.options.every((opt, i) => opt === selectedOptions[i])
    );
    if (!matchedVariant) return;
    updateVariantPrice(productBox, matchedVariant);

    
    updateVariantPrice(productBox, matchedVariant);

    const contactText = document.querySelector('.data-tex-locales')?.dataset.textContact || 'Contact';

    // Update Inputs
    if (idInput) idInput.value = matchedVariant.id;
    if (select) {
      select.value = matchedVariant.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update Price
    if (priceEl) {
      priceEl.innerHTML = matchedVariant.price === 0
        ? contactText
        : formatMoney(matchedVariant.price, moneyFormat);
    }

    if (compareEl) {
      compareEl.innerHTML =
        matchedVariant.compare_at_price > matchedVariant.price && matchedVariant.price > 0
          ? formatMoney(matchedVariant.compare_at_price, moneyFormat)
          : '';
    }

    // Update Button

    if (button && idInput) {
      let productLabels = {};
      const labelScript = wrapper.querySelector('#product-button-labels');

      try {
        productLabels = JSON.parse(labelScript?.textContent || '{}');
      } catch (e) {
        console.warn('Failed to parse product labels:', e);
      }

      const isContact = matchedVariant.price === 0;
      const isAvailable = matchedVariant.available;
      const shouldDisable = isContact || !isAvailable;
      button.disabled = shouldDisable;
      button.style.pointerEvents = shouldDisable ? 'none' : 'auto';
      const span = button.querySelector('span');
      if (span) {
        if (!isAvailable) {
          span.textContent = productLabels.inventoryOutOfStock || 'Out of stock';
        } else if (isContact) {
          span.textContent = productLabels.chooseOptions || 'Choose options';
        } else {
          span.textContent = productLabels.addToCart || 'Add to cart';
        }
      }

      button.addEventListener('click', (e) => {
        const variantId = parseInt(idInput.value, 10);
        const variant = variants.find(v => v.id === variantId);
        if (!variant || variant.price === 0 || !variant.available) {
          e.preventDefault();
        }
      });
    }



    // Disable unavailable swatches
    swatches.forEach((swatch, index) => {
      const radios = swatch.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const value = radio.value.trim();
        const testOptions = [...selectedOptions];
        testOptions[index] = value;

        const available = variants.some(v =>
          v.available && v.options.every((opt, i) => opt === testOptions[i])
        );

        const swatchEl = radio.closest('.lh-swatch-element');
        swatchEl?.classList.toggle('lh-sold-out', !available);
      });
    });
  }

});


const bundleSubmitBtn = wrapper.querySelector("[data-product-bundle-submit]");
if (mode !== "dev") {
  if (bundleSubmitBtn) {
    bundleSubmitBtn.addEventListener("click", () => {
      if (bundleState.items.length === 0) return;

      const itemsToAdd = bundleState.items.map((i) => ({
        id: i.variantId,
        quantity: i.quantity,
      }));

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      })
        .then((res) => res.json())
        .then(() => {
          bundleState.items = [];
          renderBundle();
          updateBundleTotal();

          if (typeof window.showCartDrawer === "function") {
            window.showCartDrawer();
          } else {
            window.location.href = "/cart";
          }
        })
        .catch((err) => console.error(err));
    });
  }
} 

function updateVariantPrice(wrapper, variant) {
  const priceBox = wrapper.querySelector('.lh-price-box');
  if (!priceBox) return;

  const currentPriceEl = priceBox.querySelector('.lh-current-price');
  const oldPriceEl = priceBox.querySelector('.lh-old-price');

  const formattedPrice = formatMoney(variant.price, moneyFormat);
  const formattedCompare = variant.compare_at_price
    ? formatMoney(variant.compare_at_price, moneyFormat)
    : '';

  if (currentPriceEl) currentPriceEl.textContent = formattedPrice;

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (oldPriceEl) {
      oldPriceEl.textContent = formattedCompare;
      oldPriceEl.style.display = 'inline';
    } else {
      const span = document.createElement('span');
      span.className = 'lh-old-price line-through !text-[var(--lh-other-sale-price-color)] lh-p2';
      span.textContent = formattedCompare;
      priceBox.appendChild(span);
    }
  } else if (oldPriceEl) {
    oldPriceEl.style.display = 'none';
  }
}



})(document.querySelector('section.lh-cs2r6j'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
function debounce(fn, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
} 

function animateValue({ from, to, duration, onUpdate, easing = t => t * t * (3 - 2 * t), onComplete }) {
  const startTime = performance.now();
  let cancelled = false;
  let currentValue = from; 

  function animate(currentTime) {
    if (cancelled) return;
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); 
    const eased = easing(progress); 
    currentValue = from + (to - from) * eased;

    onUpdate(currentValue);

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else if (onComplete) {
      onComplete();
    }
  }

  requestAnimationFrame(animate);

  return {
    get current() {
      return currentValue;
    },
    cancel() {
      cancelled = true;
    },
  };
}

function setupMarquee(wrapperEl, contentEl) {
  const direction = wrapperEl.dataset.direction === 'right' ? 'right' : 'left';

  function setDirectionAnimation() {
    wrapperEl.style.animationName = direction === 'right' ? 'scroll-right' : 'scroll-left';
  }

  function duplicateItemsUntilFilled() {
    const allChildren = Array.from(contentEl.children);
    const originalItems = allChildren.filter(item => !item.dataset.cloned);
    if (originalItems.length === 0) return;

    allChildren.forEach(child => {
      if (child.dataset.cloned) {
        child.remove();
      }
    });

    let totalWidth = contentEl.scrollWidth;
    const requiredWidth = window.innerWidth;
    let cloneWidth = originalItems.reduce((acc, el) => acc + el.offsetWidth, 0);
    let maxLoops = 20;

    while (totalWidth < requiredWidth && maxLoops > 0) {
      originalItems.forEach(item => {
        const clone = item.cloneNode(true);
        clone.dataset.cloned = 'true';
        contentEl.appendChild(clone);
      });
      totalWidth += cloneWidth;
      maxLoops--;
    }
  }

  function cloneContent() {
    const last = wrapperEl.lastElementChild;
    if (last !== contentEl) last?.remove();

    const clone = contentEl.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    wrapperEl.appendChild(clone);
  }

  if (!contentEl.firstElementChild) return;

  duplicateItemsUntilFilled();
  cloneContent();
  setDirectionAnimation();

  wrapperEl.addEventListener('pointerenter', () => {
    wrapperEl.classList.add('paused');
  });

  wrapperEl.addEventListener('pointerleave', () => {
    wrapperEl.classList.remove('paused');
  });

  return {
    update: () => {
      duplicateItemsUntilFilled();
      cloneContent();
      setDirectionAnimation();
    }
  };
}


 const marqueeWrapper = wrapper.querySelector('.lh-marquee-wrapper');
const marqueeContent = marqueeWrapper?.querySelector('.lh-marquee-content');

let marquee;
if (marqueeWrapper && marqueeContent) {
  marquee = setupMarquee(marqueeWrapper, marqueeContent);
}

window.addEventListener('resize', debounce(() => {
  if (marquee) marquee.update();
}, 0));
window.dispatchEvent(new Event('resize'));



})(document.querySelector('section.lh-vkuh2s'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
setTimeout(() => {
  window.LayoutHubSlider(wrapper);
}, 50);








})(document.querySelector('section.lh-lwhdia'), 'live');
}catch(ex){console.error(ex)}

try {
((wrapper, mode) => {/* LayoutHub assets/script.js */
window.LayoutHubSlider(wrapper);

const slideItems = wrapper.querySelectorAll(".lh-slide-item");
const hotspots = wrapper.querySelectorAll(".lh-hotspot");
const dotsWithImageEL = wrapper.querySelector(".lh-dots-with-image");
let isEventsBound = false;


slideItems.forEach((slideItem, index) => {
  const hotspot = hotspots[index];
  if (!hotspot) return;
  const productPreviewWrapper = hotspot.querySelector(
    ".lh-product-preview-wrapper"
  );
  if (!productPreviewWrapper) return;

  function disableLinksAndButtons(scope) {
    scope.querySelectorAll("a").forEach(a => {
      a.removeAttribute("href");
      a.addEventListener("click", e => e.preventDefault());
      a.style.cursor = "default";
    });
    scope.querySelectorAll("button").forEach(btn => {
      btn.disabled = true;
      btn.addEventListener("click", e => e.preventDefault());
      btn.style.cursor = "default";
    });
  }

  const updateClone = () => {
    const slideItemClone = slideItem.cloneNode(true);
    productPreviewWrapper.innerHTML = "";
    productPreviewWrapper.append(slideItemClone);

    if (mode === 'dev') {
      disableLinksAndButtons(slideItemClone);
    }
  };
  const observer = new MutationObserver(() => {
    updateClone();
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot)
    })
  })

  observer.observe(slideItem.querySelector(".lh-product-box"), {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true
  })
  updateClone();
});


hotspots.forEach((hotspot, index) => {
  hotspot.addEventListener('click', () => {
    const isMobile = window.innerWidth < 640;

    hotspots.forEach((hs, i) => {
      if (i === index) {
        if (isMobile) {
          hs.classList.add('active');
        } else {
          hs.classList.toggle('active');
        }
      } else {
        hs.classList.remove('active');
      }
    });

    wrapper.embla.scrollTo(index);
  });
});

function synsSlideWithHotspot() {
  const observer = new MutationObserver(() => {
    const selectedIndex = wrapper.embla.selectedScrollSnap();

    hotspots.forEach((hotspot, i) => {
      if (selectedIndex === i) hotspot.classList.add('active');
      else hotspot.classList.remove('active');
    })
  });

  slideItems.forEach((slideItem) => {
    observer.observe(slideItem, {
      attributes: true,
      attributeFilter: ["class"],
      subtree: false
    });
  });
}

function adjustPreviewDirection(tooltip, hotspot) {

  if (!tooltip || !hotspot || !dotsWithImageEL) return;
  const minOffsetTooltip = Number(
    hotspot.getAttribute("data-tooltip-min-offset")
  );

  const containerSize = {
    width: dotsWithImageEL.offsetWidth,
    height: dotsWithImageEL.offsetHeight,
  };

  const tooltipSize = {
    width: tooltip.offsetWidth,
    height: tooltip.offsetHeight,
  };

  const hotspotSize = {
    width: hotspot.offsetWidth,
    height: hotspot.offsetHeight,
  };

  const tooltipCenterOffsetX = (tooltipSize.width - hotspotSize.width) / 2;
  const tooltipOffsetLeft = hotspot.offsetLeft - tooltipCenterOffsetX;
  const tooltipOffsetRight =
    containerSize.width - (hotspot.offsetLeft + tooltipCenterOffsetX);

  const overflowX = {
    left: tooltipOffsetLeft <= minOffsetTooltip,
    right: tooltipOffsetRight <= minOffsetTooltip,
  };

  const verticalOffset = (tooltipSize.height - hotspotSize.height) / 2;
  const isOverflowX = overflowX.left || overflowX.right;

  const tooltipOffsetTop = isOverflowX
    ? hotspot.offsetTop - verticalOffset
    : hotspot.offsetTop - tooltipSize.height;

  const tooltipOffsetBottom = isOverflowX
    ? containerSize.height - (hotspot.offsetTop + verticalOffset)
    : containerSize.height - (hotspot.offsetTop + tooltipSize.height);

  const overflowY = {
    top: tooltipOffsetTop <= minOffsetTooltip,
    bottom: tooltipOffsetBottom <= minOffsetTooltip + 10,
  };

  tooltip.classList.remove(
    "lh-preview-bottom",
    "lh-preview-top",
    "lh-preview-left",
    "lh-preview-right",
    "lh-preview-top-right",
    "lh-preview-top-left",
    "lh-preview-bottom-right",
    "lh-preview-bottom-left"
  );

  if (overflowX.left && overflowY.bottom) {
    tooltip.classList.add("lh-preview-bottom-right");
  } else if (overflowX.left && overflowY.top) {
    tooltip.classList.add("lh-preview-top-right");
  } else if (overflowX.right && overflowY.top) {
    tooltip.classList.add("lh-preview-top-left");
  } else if (overflowX.right && overflowY.bottom) {
    tooltip.classList.add("lh-preview-bottom-left");
  } else if (overflowX.right) {
    tooltip.classList.add("lh-preview-left");
  } else if (overflowY.top) {
    tooltip.classList.add("lh-preview-bottom");
  } else if (overflowY.bottom) {
    tooltip.classList.add("lh-preview-top");
  } else if (overflowX.left) {
    tooltip.classList.add("lh-preview-right");
  } else {
    tooltip.classList.add("lh-preview-bottom");
  }
}

function previewCheck() {
  hotspots.forEach((hotspot) => {
    const tooltip = hotspot.querySelector(".lh-product-preview");
    const observer = new MutationObserver(() =>
      adjustPreviewDirection(tooltip, hotspot)
    );
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: [
        "data-horizontal-de",
        "data-vertical-de",
        "data-horizontal-ta",
        "data-vertical-ta",
        "data-horizontal-mo",
        "data-vertical-mo",
      ],
    });
    adjustPreviewDirection(tooltip, hotspot);
  });
};

function bindActiveEvents() {
  if (!dotsWithImageEL || isEventsBound) return;

  wrapper.addEventListener("click", handleDotsClick);
  dotsWithImageEL.querySelectorAll('.lh-product-preview').forEach((preview) => {
    preview.addEventListener("click", stopPreviewClick);
  });

  isEventsBound = true;
}

function unbindActiveEvents() {
  if (!dotsWithImageEL || !isEventsBound) return;

  wrapper.removeEventListener("click", handleDotsClick);
  dotsWithImageEL.querySelectorAll('.lh-product-preview').forEach((preview) => {
    preview.removeEventListener("click", stopPreviewClick);
  });

  isEventsBound = false;
}
function handleDotsClick(e) {
  const clickedHotspot = e.target.closest(".lh-hotspot");
  const clickedPreview = e.target.closest(".lh-product-preview");
  const clickedInsideDotsWithImage = e.target.closest('.lh-dots-with-image');

  if (!clickedHotspot && !clickedPreview && clickedInsideDotsWithImage) {
    hotspots.forEach(hotspot => hotspot.classList.remove("active"));
  }
}

function stopPreviewClick(e) {
  e.stopPropagation();
}

synsSlideWithHotspot();

if (window.innerWidth >= 640) {
  bindActiveEvents();
} else {
  unbindActiveEvents();
}

requestAnimationFrame(() => {
  previewCheck();
});

window.addEventListener("resize", () => {
  if (window.innerWidth >= 640) {
    bindActiveEvents();
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  } else {
    unbindActiveEvents();
  }
});

const appendProductsWhenIsMobile = () => {
  if (window.innerWidth <= 767) {
    const previews = wrapper.querySelectorAll(".lh-product-preview");
    const productContainer = wrapper.querySelector(".lh-product-container");
    const overlay = wrapper.querySelector(".lh-overlay");
    const products = wrapper.querySelector(".lh-products");
    if (!products || !productContainer) return;

    previews.forEach((preview) => {
      products.appendChild(preview);
      preview.classList.remove(
        "active",
        "hidden",
        "lh-preview-bottom",
        "lh-preview-top",
        "lh-preview-right",
        "lh-preview-left",
        "lh-preview-bottom-left",
        "lh-preview-top-left",
        "lh-preview-top-right",
        "lh-preview-bottom-right"
      );
    });
    

    let foundActive = false;
    hotspots.forEach((hotspot, index) => {
      const isActive = hotspot.classList.contains("active");
      if (isActive) {
        foundActive = true;
        overlay.classList.remove("hidden");
        previews.forEach((preview, i) => {
          if (i === index) {
            preview.classList.add("active");
            preview.classList.remove("hidden");
          } else {
            preview.classList.remove("active");
            preview.classList.add("hidden");
          }
        });
      }
    });

    if (!foundActive) {
      overlay.classList.add("hidden");
      previews.forEach((preview) => {
        preview.classList.remove("active");
        preview.classList.add("hidden");
      });
    }

    productContainer.classList.remove("block", "hidden");
    productContainer.classList.add(foundActive ? "block" : "hidden");
  } else {
    const previews = wrapper.querySelectorAll(".lh-product-preview");
    const spots = wrapper.querySelectorAll(".lh-spot");
    previews.forEach((preview, index) => {
      preview.classList.remove("hidden");
      const targetSpot = spots[index];
      if (targetSpot) targetSpot.appendChild(preview);
    });
    previewCheck();
  }
};
// Đóng popup khi click vào overlay (mobile)
const overlay = wrapper.querySelector(".lh-overlay");
if (overlay) {
  overlay.addEventListener("click", () => {
    hotspots.forEach(h => h.classList.remove("active"));
    overlay.classList.add("hidden");

    const previews = wrapper.querySelectorAll(".lh-product-preview");
    previews.forEach(preview => {
      preview.classList.remove("active");
      preview.classList.add("hidden");
    });

    const productContainer = wrapper.querySelector(".lh-product-container");
    if (productContainer) {
      productContainer.classList.add("hidden");
    }
  });
}



if (window.innerWidth < 640) {
  let lastScroll = window.scrollY;
  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;
    if (Math.abs(currentScroll - lastScroll) > 5) {
      hotspots.forEach((h) => h.classList.remove("active"));
      const overlay = wrapper.querySelector(".lh-overlay");
      if (overlay) overlay.classList.add("hidden");
      appendProductsWhenIsMobile();
    }
    lastScroll = currentScroll;
  });
}

appendProductsWhenIsMobile();


const observeHotspotChanges = () => {
  hotspots.forEach((hotspot) => {
    const observer = new MutationObserver(() => {
      appendProductsWhenIsMobile();
    });
    observer.observe(hotspot, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });
};
observeHotspotChanges();


window.addEventListener("resize", () => {
  if (window.innerWidth >= 640) {
    bindActiveEvents();
    hotspots.forEach((hotspot) => {
      const tooltip = hotspot.querySelector(".lh-product-preview");
      adjustPreviewDirection(tooltip, hotspot);
    });
  } else {
    unbindActiveEvents();
    appendProductsWhenIsMobile();
  }
});

/* LayoutHub assets/swatch.js */
const select = wrapper.querySelector('.lh-single-option-selector');
wrapper.querySelectorAll('.lh-product-box[data-product-id]').forEach(productBox => {
  const swatches = productBox.querySelectorAll('.lh-swatch');
  swatches.forEach(swatch => {
    const radios = swatch.querySelectorAll('input[type="radio"]');
    for (let i = 0; i < radios.length; i++) {
      const radio = radios[i];
      const swatchElement = radio.closest('.lh-swatch-element');
      if (radio.disabled || swatchElement?.classList.contains('lh-sold-out')) continue;
      radio.checked = true;
      selected = true;
      if (swatchElement?.classList.contains('lh-color')) {
        const dataSrc = swatchElement.getAttribute('data-src');
        if (dataSrc) {
          const productBox = swatchElement.closest('.lh-product-box');
          const thumbnail = productBox?.querySelector('.lh-product-thumbnail .img-with-variant');
          if (thumbnail) {
            thumbnail.src = dataSrc;
          }
        }
      }
      break;
    }
  });
});
function updateSelectedVariant() {
  const swatchContainers = wrapper.querySelectorAll('.lh-swatch');
  const selectedOptions = [];
  swatchContainers.forEach(container => {
    const checked = container.querySelector('input[type="radio"]:checked');
    if (checked) selectedOptions.push(checked.value.trim());
  });
  const selectedTitle = selectedOptions.join(' / ').trim();
  if (select) {
    const options = select.querySelectorAll('option');
    options.forEach(option => {
      const titleText = option.textContent.trim().split(' - ')[0];
      if (titleText === selectedTitle) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}

wrapper.addEventListener('change', function (e) {
  if (!e.target.matches('.lh-swatch .lh-swatch-element input[type="radio"]')) return;
  updateSelectedVariant();
});
updateSelectedVariant();

wrapper.addEventListener('click', function (e) {
  const swatchEl = e.target.closest('.lh-swatch-element.lh-color');

  if (!swatchEl) return;
  const dataSrc = swatchEl.getAttribute('data-src');
 
  if (dataSrc) {
     const productBox = swatchEl.closest('.lh-product-box');
    const thumbnail = productBox?.querySelector('.lh-product-thumbnail .img-with-variant');
    if (thumbnail) {
       thumbnail.src = dataSrc;
      thumbnail.srcset = dataSrc;
    }
  } 
});

})(document.querySelector('section.lh-jtgk61'), 'live');
}catch(ex){console.error(ex)}
